/* istanbul ignore file */
/* tslint:disable */

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
import type { AddBrandDto } from '../models/AddBrandDto'
import type { AddFamilyDto } from '../models/AddFamilyDto'
import type { AddGroupDto } from '../models/AddGroupDto'
import type { AddMachineOptionDto } from '../models/AddMachineOptionDto'
import type { ArchivedEquipmentDto } from '../models/ArchivedEquipmentDto'
import type { AttachmentItemDto } from '../models/AttachmentItemDto'
import type { AttachmentTemplateDto } from '../models/AttachmentTemplateDto'
import type { BrandAliasDto } from '../models/BrandAliasDto'
import type { BrandMachineAttachmentItemDto } from '../models/BrandMachineAttachmentItemDto'
import type { BrandMachineItemDto } from '../models/BrandMachineItemDto'
import type { BrandOrderDto } from '../models/BrandOrderDto'
import type { BrandRulesDto } from '../models/BrandRulesDto'
import type { BrandWarrantyDto } from '../models/BrandWarrantyDto'
import type { BrandWarrantyQuotationItemDto } from '../models/BrandWarrantyQuotationItemDto'
import type { ConfigurationRuleGroupDto } from '../models/ConfigurationRuleGroupDto'
import type { CreatePriceRulesDto } from '../models/CreatePriceRulesDto'
import type { CreateVatDto } from '../models/CreateVatDto'
import type { CultureChangedEventData } from '../models/CultureChangedEventData'
import type { CultureResponseDto } from '../models/CultureResponseDto'
import type { CustomerContactChangePubSubData } from '../models/CustomerContactChangePubSubData'
import type { CustomerPubSubData } from '../models/CustomerPubSubData'
import type { CustomMachineAttachmentFactoryAndDealerOptionDto } from '../models/CustomMachineAttachmentFactoryAndDealerOptionDto'
import type { CustomMachineFactoryAndDealerOptionDto } from '../models/CustomMachineFactoryAndDealerOptionDto'
import type { CustomMachineMachineAttachmentFactoryAndDealerOptionDto } from '../models/CustomMachineMachineAttachmentFactoryAndDealerOptionDto'
import type { DealerOptionBaseDto } from '../models/DealerOptionBaseDto'
import type { DealerOptionDto } from '../models/DealerOptionDto'
import type { DeleteCustomerBillingAddressPubSubData } from '../models/DeleteCustomerBillingAddressPubSubData'
import type { DeleteCustomerDeliveryLocationPubSubData } from '../models/DeleteCustomerDeliveryLocationPubSubData'
import type { EquipmentBaseItemDto } from '../models/EquipmentBaseItemDto'
import type { EquipmentInStockItemDto } from '../models/EquipmentInStockItemDto'
import type { EquipmentListItem } from '../models/EquipmentListItem'
import type { EquipmentListItemDto } from '../models/EquipmentListItemDto'
import type { EquipmentListItemsWithMultipleQuotesDto } from '../models/EquipmentListItemsWithMultipleQuotesDto'
import type { EquipmentRuleDto } from '../models/EquipmentRuleDto'
import type { FactoryOptionDto } from '../models/FactoryOptionDto'
import type { FamilyDto } from '../models/FamilyDto'
import type { FamilyItemDto } from '../models/FamilyItemDto'
import type { FullAttachmentRuleDto } from '../models/FullAttachmentRuleDto'
import type { FullFamilyDto } from '../models/FullFamilyDto'
import type { FullGroupDto } from '../models/FullGroupDto'
import type { FullMachineRuleDto } from '../models/FullMachineRuleDto'
import type { GetBrandDto } from '../models/GetBrandDto'
import type { GetQuotationPaginatedDto } from '../models/GetQuotationPaginatedDto'
import type { GroupDto } from '../models/GroupDto'
import type { IdsTenantEventData } from '../models/IdsTenantEventData'
import type { IdsTenantEventStringData } from '../models/IdsTenantEventStringData'
import type { ImportResultDto } from '../models/ImportResultDto'
import type { InternalApprovalRuleCheckDto } from '../models/InternalApprovalRuleCheckDto'
import type { ListMachineRuleDto } from '../models/ListMachineRuleDto'
import type { MachineAttachmentDto } from '../models/MachineAttachmentDto'
import type { MachineAttachmentItemDto } from '../models/MachineAttachmentItemDto'
import type { MachineAttachmentItemUpdateDto } from '../models/MachineAttachmentItemUpdateDto'
import type { MachineAttachmentRuleDto } from '../models/MachineAttachmentRuleDto'
import type { MachineCompatibilityDto } from '../models/MachineCompatibilityDto'
import type { MachineDto } from '../models/MachineDto'
import type { MachineItemDto } from '../models/MachineItemDto'
import type { MachineQuotationItemDto } from '../models/MachineQuotationItemDto'
import type { MachineQuotationItemUpdateDto } from '../models/MachineQuotationItemUpdateDto'
import type { MachineRuleDto } from '../models/MachineRuleDto'
import type { MachineTemplateDto } from '../models/MachineTemplateDto'
import type { PaginatedRequestContinueDto } from '../models/PaginatedRequestContinueDto'
import type { ParsingPhaseDto } from '../models/ParsingPhaseDto'
import type { PriceRuleDto } from '../models/PriceRuleDto'
import type { QuotationDto } from '../models/QuotationDto'
import type { QuotationFactorySupportValuesDto } from '../models/QuotationFactorySupportValuesDto'
import type { QuotationHistory } from '../models/QuotationHistory'
import type { QuotationInfoDto } from '../models/QuotationInfoDto'
import type { QuotationItemOrderDto } from '../models/QuotationItemOrderDto'
import type { QuotationListDto } from '../models/QuotationListDto'
import type { QuotationMarginDto } from '../models/QuotationMarginDto'
import type { QuotationMetadataUpdateDto } from '../models/QuotationMetadataUpdateDto'
import type { QuotationMetatadaTableDto } from '../models/QuotationMetatadaTableDto'
import type { QuotationSellPriceDto } from '../models/QuotationSellPriceDto'
import type { QuotationStatusEnum } from '../models/QuotationStatusEnum'
import type { QuotationSummaryCustomerQuoteDto } from '../models/QuotationSummaryCustomerQuoteDto'
import type { QuotationSummaryDto } from '../models/QuotationSummaryDto'
import type { QuotationSummaryInternalApprovalPdfDto } from '../models/QuotationSummaryInternalApprovalPdfDto'
import type { QuotationSummarySalesSupportDto } from '../models/QuotationSummarySalesSupportDto'
import type { QuotationUpdateDto } from '../models/QuotationUpdateDto'
import type { QuotationWithNewObjectIdDto } from '../models/QuotationWithNewObjectIdDto'
import type { RulesByAttachmentsDto } from '../models/RulesByAttachmentsDto'
import type { RulesByMachinesDto } from '../models/RulesByMachinesDto'
import type { SaveAttachmentRuleDto } from '../models/SaveAttachmentRuleDto'
import type { SaveMachineRuleDto } from '../models/SaveMachineRuleDto'
import type { ServiceContractDto } from '../models/ServiceContractDto'
import type { SpecificationDto } from '../models/SpecificationDto'
import type { SpecificationPaginatedDto } from '../models/SpecificationPaginatedDto'
import type { StockDataDto } from '../models/StockDataDto'
import type { StockDto } from '../models/StockDto'
import type { StockLifeCycleCostDto } from '../models/StockLifeCycleCostDto'
import type { StockLinkingDto } from '../models/StockLinkingDto'
import type { StockMachineAttachmentDataDto } from '../models/StockMachineAttachmentDataDto'
import type { StockMachineAttachmentDto } from '../models/StockMachineAttachmentDto'
import type { StockMachineDataDto } from '../models/StockMachineDataDto'
import type { StockMachineDto } from '../models/StockMachineDto'
import type { TradeInItemDto } from '../models/TradeInItemDto'
import type { TradeInManufacturerDto } from '../models/TradeInManufacturerDto'
import type { TransportOptionDto } from '../models/TransportOptionDto'
import type { UpdateFamilyDto } from '../models/UpdateFamilyDto'
import type { UploadFileInfoDto } from '../models/UploadFileInfoDto'
import type { ValidateAttachmentTemplateDto } from '../models/ValidateAttachmentTemplateDto'
import type { ValidateMachineTemplateDto } from '../models/ValidateMachineTemplateDto'
import type { VatDto } from '../models/VatDto'
import type { WarrantyDto } from '../models/WarrantyDto'

export class MachinesApiService {
  /**
   * Method allows you to receive all brands
   * @returns GetBrandDto OK
   * @throws ApiError
   */
  public static allbrands(): CancelablePromise<Array<GetBrandDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/allbrands',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to receive all brands by id's
   * @param requestBody
   * @returns GetBrandDto OK
   * @throws ApiError
   */
  public static brandsByIds(
    requestBody: Array<number>
  ): CancelablePromise<Array<GetBrandDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Brands',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows to archive a brand by id
   * @param id
   * @returns number OK
   * @throws ApiError
   */
  public static archiveBrand(id: number): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Brands/{id}/Archive',
      path: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows to restore an archived brand by id
   * @param id
   * @returns number OK
   * @throws ApiError
   */
  public static restoreArchivedBrand(id: number): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Brands/{id}/RestoreArchived',
      path: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update Brands Order
   * @param requestBody
   * @returns BrandOrderDto OK
   * @throws ApiError
   */
  public static updateBrandsOrder(
    requestBody: Array<BrandOrderDto>
  ): CancelablePromise<Array<BrandOrderDto>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Brands/UpdateOrder',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to receive all brands
   * @returns BrandRulesDto OK
   * @throws ApiError
   */
  public static allBrandsRules(): CancelablePromise<Array<BrandRulesDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/AllBrandsRules',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to receive all equipments with rules
   * @returns EquipmentRuleDto OK
   * @throws ApiError
   */
  public static allEquipmentRules(): CancelablePromise<
    Array<EquipmentRuleDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/AllEquipmentRules'
    })
  }

  /**
   * Method allows you to get brand by name
   * @param name
   * @returns GetBrandDto OK
   * @throws ApiError
   */
  public static getBrandByName(name: string): CancelablePromise<GetBrandDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/brand',
      query: {
        name: name
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get brand machines
   * @param name
   * @returns MachineDto OK
   * @throws ApiError
   */
  public static getMachinesByBrandName(
    name: string
  ): CancelablePromise<Array<MachineDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/brand/machines',
      query: {
        name: name
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allow you to get brands by type
   * @param type
   * @returns GetBrandDto OK
   * @throws ApiError
   */
  public static brandGetBrandsByType(
    type: string
  ): CancelablePromise<Array<GetBrandDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/brand/getBrandsByType',
      query: {
        type: type
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update brand name
   * @param brandName
   * @param newBrandName
   * @returns GetBrandDto Created
   * @throws ApiError
   */
  public static updateBrandName(
    brandName: string,
    newBrandName: string
  ): CancelablePromise<GetBrandDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/UpdateBrandName',
      query: {
        brandName: brandName,
        newBrandName: newBrandName
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param brandName
   * @param width
   * @param height
   * @param formData
   * @returns GetBrandDto Created
   * @throws ApiError
   */
  public static postUpdateBrandLogo(
    brandName: string,
    width: number,
    height: number,
    formData?: {
      file: Blob
    }
  ): CancelablePromise<GetBrandDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/UpdateBrandLogo',
      query: {
        brandName: brandName,
        width: width,
        height: height
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create new brand
   * @param requestBody
   * @returns GetBrandDto Created
   * @throws ApiError
   */
  public static addBrand(
    requestBody: AddBrandDto
  ): CancelablePromise<GetBrandDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Brand',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to receive all brand aliases filtered by name
   * @param requestBody
   * @returns BrandAliasDto OK
   * @throws ApiError
   */
  public static allBrandsAliasesByNames(
    requestBody: Array<string>
  ): CancelablePromise<Array<BrandAliasDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/AllBrandAliasByName',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create new Brand Alias for a Brand
   * @param brandId
   * @param requestBody
   * @returns BrandAliasDto Created
   * @throws ApiError
   */
  public static addBrandAlias(
    brandId: number,
    requestBody: BrandAliasDto
  ): CancelablePromise<BrandAliasDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/BrandAlias',
      query: {
        brandId: brandId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update Brand Alias for a Brand
   * @param brandId
   * @param requestBody
   * @returns BrandAliasDto Created
   * @throws ApiError
   */
  public static updateBrandAlias(
    brandId: number,
    requestBody: BrandAliasDto
  ): CancelablePromise<BrandAliasDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/BrandAlias',
      query: {
        brandId: brandId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete Brand Alias for a Brand
   * @param brandId
   * @param brandAliasId
   * @returns BrandAliasDto Created
   * @throws ApiError
   */
  public static deleteBrandAlias(
    brandId: number,
    brandAliasId: number
  ): CancelablePromise<BrandAliasDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/BrandAlias',
      query: {
        brandId: brandId,
        brandAliasId: brandAliasId
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create new List of Brand Alias for a Brand
   * @param brandId
   * @param requestBody
   * @returns BrandAliasDto Created
   * @throws ApiError
   */
  public static addBrandAliases(
    brandId: number,
    requestBody: Array<BrandAliasDto>
  ): CancelablePromise<Array<BrandAliasDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/BrandAliases',
      query: {
        brandId: brandId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param formData
   * @returns BrandWarrantyDto OK
   * @throws ApiError
   */
  public static postPostBrandWarrantyExcel(formData?: {
    file: Blob
  }): CancelablePromise<BrandWarrantyDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/PostBrandWarrantyExcel',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        415: `Unsupported Media Type`
      }
    })
  }

  /**
   * @param notes
   * @param brandId
   * @param useBrandWarrantyDiscount
   * @param brandWarrantyDiscount
   * @param formData
   * @returns BrandWarrantyDto OK
   * @throws ApiError
   */
  public static postCreateUpdateBrandWarrantyExcel(
    notes: string,
    brandId: number,
    useBrandWarrantyDiscount: boolean,
    brandWarrantyDiscount?: number,
    formData?: {
      file: Blob
    }
  ): CancelablePromise<BrandWarrantyDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateUpdateBrandWarrantyExcel',
      query: {
        notes: notes,
        brandId: brandId,
        brandWarrantyDiscount: brandWarrantyDiscount,
        useBrandWarrantyDiscount: useBrandWarrantyDiscount
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        415: `Unsupported Media Type`,
        422: `Unprocessable Content`
      }
    })
  }

  /**
   * Method allows you to get brand warranties by brand id
   * @param brandId
   * @returns BrandWarrantyDto OK
   * @throws ApiError
   */
  public static getBrandWarrantiesByBrandId(
    brandId: number
  ): CancelablePromise<Array<BrandWarrantyDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Brands/Warranties',
      query: {
        brandId: brandId
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to enable or disable the usage of brand warranties
   * @param brandId
   * @param enable
   * @returns GetBrandDto OK
   * @throws ApiError
   */
  public static updateUseBrandWarranty(
    brandId: number,
    enable: boolean
  ): CancelablePromise<GetBrandDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Brands/UseBrandWarranty',
      query: {
        brandId: brandId,
        enable: enable
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get equipment data by brand id and model year
   * @param brandId
   * @param manufactureYear
   * @param equipmentType
   * @returns EquipmentBaseItemDto OK
   * @throws ApiError
   */
  public static getEquipmentBaseItemsAsync(
    brandId: number,
    manufactureYear: number,
    equipmentType: string
  ): CancelablePromise<Array<EquipmentBaseItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Brands/GetEquipmentBaseItems',
      query: {
        brandId: brandId,
        manufactureYear: manufactureYear,
        equipmentType: equipmentType
      },
      errors: {
        400: `Bad Request`
      }
    })
  }

  /**
   * Method allow you to create new price rule for brand
   * @param brandId
   * @param requestBody
   * @returns any Created
   * @throws ApiError
   */
  public static createBrandPriceRule(
    brandId: number,
    requestBody: PriceRuleDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateBrandPriceRule',
      query: {
        brandId: brandId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get machines
   * @param brandName
   * @param modelName
   * @param manufactureYear
   * @returns MachineDto OK
   * @throws ApiError
   */
  public static getMachineByBrandName(
    brandName: string,
    modelName: string,
    manufactureYear: string
  ): CancelablePromise<MachineDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/machine',
      query: {
        brandName: brandName,
        modelName: modelName,
        manufactureYear: manufactureYear
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get machine by id
   * @param id
   * @param withArchived
   * @returns MachineDto OK
   * @throws ApiError
   */
  public static getMachineById(
    id: number,
    withArchived: boolean = false
  ): CancelablePromise<MachineDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/machineId',
      query: {
        id: id,
        withArchived: withArchived
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allow to archive machines
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static archiveMachines(
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/machines/Archive',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allow to restore from archive machines
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static restoreArchiveMachines(
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/machines/RestoreArchive',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method for archiving equipment by brand id
   * @param brandId
   * @returns any OK
   * @throws ApiError
   */
  public static archiveEquipmentByBrandId(
    brandId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/machines/ArchiveFactoryOrderItems',
      query: {
        brandId: brandId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method for restoring archived factory order items by brand id
   * @param brandId
   * @returns any OK
   * @throws ApiError
   */
  public static restoreArchivedFactoryOrderItemsByBrandId(
    brandId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/machines/RestoreArchivedFactoryOrderItems',
      query: {
        brandId: brandId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows to enable the visibility of machine items
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static hideMachines(
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/machines/Hide',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows to disable the visibility of machine items
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static unhideMachines(
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/machines/Unhide',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allow to get list of machines categories
   * @returns string OK
   * @throws ApiError
   */
  public static getMachineCategories(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/machines/Categories',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get unapplicable machine ids for template
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static machineValidateMachinesByTemplates(
    requestBody: ValidateMachineTemplateDto
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ValidateMachines/Templates',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`
      }
    })
  }

  /**
   * Method allows you to add new service option
   * @param machineId
   * @param requestBody
   * @returns ServiceContractDto OK
   * @throws ApiError
   */
  public static machineAddServiceOption(
    machineId: number,
    requestBody: ServiceContractDto
  ): CancelablePromise<ServiceContractDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/machine/ServiceOption',
      query: {
        machineId: machineId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to replace service option
   * @param machineId
   * @param requestBody
   * @returns ServiceContractDto OK
   * @throws ApiError
   */
  public static machineReplaceServiceOption(
    machineId: number,
    requestBody: ServiceContractDto
  ): CancelablePromise<ServiceContractDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/machine/ServiceOption',
      query: {
        machineId: machineId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete service option
   * @param machineId
   * @param optionId
   * @returns any OK
   * @throws ApiError
   */
  public static machineDeleteServiceOption(
    machineId: number,
    optionId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/machine/ServiceOption',
      query: {
        machineId: machineId,
        optionId: optionId
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add transport option
   * @param machineId
   * @param requestBody
   * @returns TransportOptionDto OK
   * @throws ApiError
   */
  public static machineAddTransportOption(
    machineId: number,
    requestBody: TransportOptionDto
  ): CancelablePromise<TransportOptionDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/machine/TransportOption',
      query: {
        machineId: machineId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update transport option
   * @param machineId
   * @param requestBody
   * @returns TransportOptionDto OK
   * @throws ApiError
   */
  public static machineUpdateTransportOption(
    machineId: number,
    requestBody: TransportOptionDto
  ): CancelablePromise<TransportOptionDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/machine/TransportOption',
      query: {
        machineId: machineId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete transport option
   * @param machineId
   * @param optionId
   * @returns boolean OK
   * @throws ApiError
   */
  public static machineDeleteTransportOption(
    machineId: number,
    optionId: number
  ): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/machine/TransportOption',
      query: {
        machineId: machineId,
        optionId: optionId
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param formData
   * @returns ParsingPhaseDto OK
   * @throws ApiError
   */
  public static postUploadPostMachineExcel(formData?: {
    file: Blob
  }): CancelablePromise<Array<ParsingPhaseDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Upload/PostMachineExcel',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param notes
   * @param formData
   * @returns ImportResultDto OK
   * @throws ApiError
   */
  public static postUploadSaveOrUpdateMachineExcel(
    notes: string,
    formData?: {
      file: Blob
    }
  ): CancelablePromise<ImportResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Upload/SaveOrUpdateMachineExcel',
      query: {
        notes: notes
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param formData
   * @returns WarrantyDto OK
   * @throws ApiError
   */
  public static postPostWarrantyExcel(formData?: {
    file: Blob
  }): CancelablePromise<Array<WarrantyDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/PostWarrantyExcel',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param notes
   * @param formData
   * @returns any Created
   * @throws ApiError
   */
  public static postSaveOrUpdateWarrantyExcel(
    notes: string,
    formData?: {
      file: Blob
    }
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveOrUpdateWarrantyExcel',
      query: {
        notes: notes
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param formData
   * @returns any OK
   * @throws ApiError
   */
  public static postParseWarrantyAttachmentExcel(formData?: {
    file: Blob
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ParseWarrantyAttachmentExcel',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get new equipment list
   * @param brandId
   * @returns EquipmentListItemDto OK
   * @throws ApiError
   */
  public static equipmentsGetNewList(
    brandId: number
  ): CancelablePromise<Array<EquipmentListItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/brands/{brandId}/equipments/new',
      path: {
        brandId: brandId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get stock equipment list
   * @param brandId
   * @returns EquipmentInStockItemDto OK
   * @throws ApiError
   */
  public static equipmentsGetStockList(
    brandId: number
  ): CancelablePromise<Array<EquipmentInStockItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/brands/{brandId}/equipments/instock',
      path: {
        brandId: brandId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create new price rules for machines
   * @param requestBody
   * @returns MachineRuleDto Created
   * @throws ApiError
   */
  public static createMachinePriceRules(
    requestBody: CreatePriceRulesDto
  ): CancelablePromise<Array<MachineRuleDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/MachinePriceRules',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update existing price rules for machines without saving
   * @param requestBody
   * @returns string Created
   * @throws ApiError
   */
  public static calculateFactor(
    requestBody: PriceRuleDto
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CalculateFactor',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete exising price rule for machine
   * @param machineId
   * @returns any Created
   * @throws ApiError
   */
  public static deleteMachinePriceRule(
    machineId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/MachinePriceRule',
      query: {
        machineId: machineId
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update exising price rule
   * @param requestBody
   * @returns any Created
   * @throws ApiError
   */
  public static updatePriceRule(
    requestBody: PriceRuleDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/UpdatePriceRule',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param formData
   * @returns ParsingPhaseDto OK
   * @throws ApiError
   */
  public static postUploadPostDealerOptionsExcel(formData?: {
    file: Blob
  }): CancelablePromise<Array<ParsingPhaseDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Upload/PostDealerOptionsExcel',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param formData
   * @returns ParsingPhaseDto OK
   * @throws ApiError
   */
  public static postUploadPostAttachmentDealerOptionsExcel(formData?: {
    file: Blob
  }): CancelablePromise<Array<ParsingPhaseDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Upload/PostAttachmentDealerOptionsExcel',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param notes
   * @param formData
   * @returns ParsingPhaseDto OK
   * @throws ApiError
   */
  public static postUploadCreateUpdateDealerOptionsExcel(
    notes: string,
    formData?: {
      file: Blob
    }
  ): CancelablePromise<Array<ParsingPhaseDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Upload/CreateUpdateDealerOptionsExcel',
      query: {
        notes: notes
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param notes
   * @param formData
   * @returns DealerOptionDto OK
   * @throws ApiError
   */
  public static postUploadCreateUpdateAttachmentDealerOptionsExcel(
    notes: string,
    formData?: {
      file: Blob
    }
  ): CancelablePromise<Array<DealerOptionDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Upload/CreateUpdateAttachmentDealerOptionsExcel',
      query: {
        notes: notes
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get DealerOptions for machines
   * @param machineId
   * @param withArchived
   * @returns DealerOptionDto OK
   * @throws ApiError
   */
  public static dealerOptions(
    machineId: number,
    withArchived?: boolean
  ): CancelablePromise<Array<DealerOptionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Machine/DealerOptions',
      query: {
        machineId: machineId,
        withArchived: withArchived
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get all Attachment Dealer Options by attachment Id
   * @param attachmentId
   * @param withArchived
   * @returns DealerOptionBaseDto OK
   * @throws ApiError
   */
  public static attachmentDealerOptions(
    attachmentId: number,
    withArchived: boolean = false
  ): CancelablePromise<Array<DealerOptionBaseDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Attachment/DealerOptions',
      query: {
        attachmentId: attachmentId,
        withArchived: withArchived
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to receive dealer option values
   * @param requestBody
   * @returns DealerOptionDto OK
   * @throws ApiError
   */
  public static dealerOptionGetOptionsIds(
    requestBody: Array<number>
  ): CancelablePromise<Array<DealerOptionDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/DealerOption/GetOptionsByIds',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to receive factory option values
   * @param requestBody
   * @returns FactoryOptionDto OK
   * @throws ApiError
   */
  public static factoryOptionGetOptionsIds(
    requestBody: Array<number>
  ): CancelablePromise<Array<FactoryOptionDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/FactoryOption/GetOptionsByIds',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to get upload file infos
   * @returns UploadFileInfoDto OK
   * @throws ApiError
   */
  public static uploadFileInfos(): CancelablePromise<Array<UploadFileInfoDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/UploadFileInfos',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get upload file infos with paging
   * @returns UploadFileInfoDto OK
   * @throws ApiError
   */
  public static uploadFileInfosPaginated(): CancelablePromise<
    Array<UploadFileInfoDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetAllUploadFileInfosTable',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get brand MachineAttachments
   * @param brandName
   * @returns MachineAttachmentDto OK
   * @throws ApiError
   */
  public static getMachineAttachmentsByBrandName(
    brandName: string
  ): CancelablePromise<Array<MachineAttachmentDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/brand/MachineAttachments',
      query: {
        brandName: brandName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get machines
   * @param brandName
   * @param modelName
   * @param manufactureYear
   * @returns MachineAttachmentDto OK
   * @throws ApiError
   */
  public static getMachineAttachmentByBrandName(
    brandName: string,
    modelName: string,
    manufactureYear: string
  ): CancelablePromise<MachineAttachmentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/MachineAttachment',
      query: {
        brandName: brandName,
        modelName: modelName,
        manufactureYear: manufactureYear
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get MachineAttachments for machines
   * @param machineId
   * @returns MachineAttachmentDto OK
   * @throws ApiError
   */
  public static getMachineAttachmentsForMachine(
    machineId: number
  ): CancelablePromise<Array<MachineAttachmentDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Machine/Attachments',
      query: {
        machineId: machineId
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows to archive machine attachments
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static archiveMachineAttachments(
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Machine/Attachments/Archive',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows to restore archived machine attachments
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static restoreArchiveMachineAttachments(
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Machine/Attachments/RestoreArchive',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows to enable the visibility of machine attachment items
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static hideMachineAttachments(
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Machine/Attachments/Hide',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows to disable the visibility of machine attachment items
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static unhideMachineAttachments(
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Machine/Attachments/Unhide',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allow to get list of attachment categories
   * @returns string OK
   * @throws ApiError
   */
  public static getAttachmentCategories(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Machine/Attachments/Categories',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get attachment's brands by machine
   * @param machineId
   * @returns GetBrandDto OK
   * @throws ApiError
   */
  public static getCatalogAndStockAttachmentsBrandsForMachine(
    machineId: number
  ): CancelablePromise<Array<GetBrandDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Machines/{machineId}/Attachments/Brands',
      path: {
        machineId: machineId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get catalog and in stock attachments by machine and brand
   * @param machineId
   * @param brandId
   * @returns StockMachineAttachmentDto OK
   * @throws ApiError
   */
  public static getCatalogAndStockAttachmentsForMachine(
    machineId: number,
    brandId: number
  ): CancelablePromise<Array<StockMachineAttachmentDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Machines/{machineId}/Attachments/Brands/{brandId}',
      path: {
        machineId: machineId,
        brandId: brandId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to receive the list of available attachments by the list of ids
   * @param requestBody
   * @returns MachineAttachmentDto OK
   * @throws ApiError
   */
  public static getMachinesAttachmentsPriceRules(
    requestBody: Array<number>
  ): CancelablePromise<Array<MachineAttachmentDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/GetMachinesAttachmentsPriceRules',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get unapplicable attachment ids for template
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static machineValidateAttachmentsByTemplates(
    requestBody: ValidateAttachmentTemplateDto
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ValidateAttachments/Templates',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`
      }
    })
  }

  /**
   * Method allows you to get MachineAttachment
   * @param id
   * @param withArchived
   * @returns MachineAttachmentDto OK
   * @throws ApiError
   */
  public static getMachineAttachmentById(
    id: number,
    withArchived: boolean = false
  ): CancelablePromise<MachineAttachmentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Attachment',
      query: {
        id: id,
        withArchived: withArchived
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to parse MachineAttachments excel file
   * @param formData
   * @returns ParsingPhaseDto OK
   * @throws ApiError
   */
  public static uploadPostMachineAttachmentExcel(formData?: {
    file: Blob
  }): CancelablePromise<Array<ParsingPhaseDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Upload/PostMachineAttachmentExcel',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create or update MachineAttachments from excel file
   * @param notes
   * @param formData
   * @returns ImportResultDto OK
   * @throws ApiError
   */
  public static uploadSaveOrUpdateMachineAttachmentExcel(
    notes: string,
    formData?: {
      file: Blob
    }
  ): CancelablePromise<ImportResultDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Upload/SaveOrUpdateMachineAttachmentExcel',
      query: {
        notes: notes
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * @param notes
   * @param formData
   * @returns any Created
   * @throws ApiError
   */
  public static postSaveOrUpdateWarrantyAttachmentExcel(
    notes: string,
    formData?: {
      file: Blob
    }
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/SaveOrUpdateWarrantyAttachmentExcel',
      query: {
        notes: notes
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add transport option
   * @param machineId
   * @param requestBody
   * @returns TransportOptionDto OK
   * @throws ApiError
   */
  public static machineAttachmentAddTransportOption(
    machineId: number,
    requestBody: TransportOptionDto
  ): CancelablePromise<TransportOptionDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/MachineAttachment/TransportOption',
      query: {
        machineId: machineId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update transport option
   * @param machineId
   * @param requestBody
   * @returns TransportOptionDto OK
   * @throws ApiError
   */
  public static machineAttachmentUpdateTransportOption(
    machineId: number,
    requestBody: TransportOptionDto
  ): CancelablePromise<TransportOptionDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/MachineAttachment/TransportOption',
      query: {
        machineId: machineId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete transport option
   * @param machineId
   * @param optionId
   * @returns boolean OK
   * @throws ApiError
   */
  public static machineAttachmentDeleteTransportOption(
    machineId: number,
    optionId: number
  ): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/MachineAttachment/TransportOption',
      query: {
        machineId: machineId,
        optionId: optionId
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create new price rules for machines
   * @param requestBody
   * @returns MachineAttachmentRuleDto Created
   * @throws ApiError
   */
  public static machineAttachmentsCreatePriceRules(
    requestBody: CreatePriceRulesDto
  ): CancelablePromise<Array<MachineAttachmentRuleDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/MachineAttachments/PriceRules',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete exising price rule for machine
   * @param machineId
   * @returns any Created
   * @throws ApiError
   */
  public static machineAttachmentDeletePriceRule(
    machineId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/MachineAttachment/PriceRule',
      query: {
        machineId: machineId
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add machine family
   * @param requestBody
   * @returns FamilyDto OK
   * @throws ApiError
   */
  public static familyAddMachine(
    requestBody: AddFamilyDto
  ): CancelablePromise<FamilyDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/Machine',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to add attachment family
   * @param requestBody
   * @returns FamilyDto OK
   * @throws ApiError
   */
  public static familyAddAttachment(
    requestBody: AddFamilyDto
  ): CancelablePromise<FamilyDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/Attachment',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to update machine family
   * @param id
   * @param requestBody
   * @returns FamilyDto OK
   * @throws ApiError
   */
  public static familyUpdateMachine(
    id: number,
    requestBody: UpdateFamilyDto
  ): CancelablePromise<FamilyDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Family/Machine/{id}',
      path: {
        id: id
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete machine family
   * @param id
   * @returns any OK
   * @throws ApiError
   */
  public static familyDeleteMachine(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Family/Machine/{id}',
      path: {
        id: id
      }
    })
  }

  /**
   * Method allows you to update attachment family
   * @param id
   * @param requestBody
   * @returns FamilyDto OK
   * @throws ApiError
   */
  public static familyUpdateAttachment(
    id: number,
    requestBody: UpdateFamilyDto
  ): CancelablePromise<FamilyDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Family/Attachment/{id}',
      path: {
        id: id
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete attachment family
   * @param id
   * @returns any OK
   * @throws ApiError
   */
  public static familyDeleteAttachment(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Family/Attachment/{id}',
      path: {
        id: id
      }
    })
  }

  /**
   * Method allows you to get unassigned base units
   * @param requestBody
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyMachineBaseUnitUnassignedPost(
    requestBody: Array<number>
  ): CancelablePromise<Array<FamilyItemDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/Machine/BaseUnit/UnassignedPost',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get unassigned base units
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyMachineBaseUnitUnassigned(): CancelablePromise<
    Array<FamilyItemDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Family/Machine/BaseUnit/Unassigned'
    })
  }

  /**
   * Method allows you to get unassigned factory fit options
   * @param requestBody
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyMachineFactoryFitUnassignedPost(
    requestBody: Array<number>
  ): CancelablePromise<Array<FamilyItemDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/Machine/FactoryFit/UnassignedPost',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get unassigned factory fit options
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyMachineFactoryFitUnassigned(): CancelablePromise<
    Array<FamilyItemDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Family/Machine/FactoryFit/Unassigned'
    })
  }

  /**
   * Method allows you to get unassigned dealer fit options
   * @param withArchived
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyMachineDealerFitUnassigned(
    withArchived?: boolean
  ): CancelablePromise<Array<FamilyItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Family/Machine/DealerFit/Unassigned',
      query: {
        withArchived: withArchived
      }
    })
  }

  /**
   * Method allows you to get families with base unit factory options
   * @returns FullFamilyDto OK
   * @throws ApiError
   */
  public static familiesMachineBaseUnits(): CancelablePromise<
    Array<FullFamilyDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Families/Machine/BaseUnits'
    })
  }

  /**
   * Method allows you to get families with base unit factory fit options
   * @returns FullFamilyDto OK
   * @throws ApiError
   */
  public static familiesMachineFactoryFits(): CancelablePromise<
    Array<FullFamilyDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Families/Machine/FactoryFits'
    })
  }

  /**
   * Method allows you to get families with dealer fit options
   * @param withArchived
   * @returns FullFamilyDto OK
   * @throws ApiError
   */
  public static familiesMachineDealerFits(
    withArchived?: boolean
  ): CancelablePromise<Array<FullFamilyDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Families/Machine/DealerFits',
      query: {
        withArchived: withArchived
      }
    })
  }

  /**
   * Method allows you to delete factory machine items from family
   * @param familyId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static familyFamilyIdMachineUnlinkItems(
    familyId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/{familyId}/Machine/UnlinkItems',
      path: {
        familyId: familyId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete dealer fits from family
   * @param familyId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static familyFamilyIdMachineUnlinkDealerFits(
    familyId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/{familyId}/Machine/UnlinkDealerFits',
      path: {
        familyId: familyId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to link factory machine item to family
   * @param familyId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static familyFamilyIdMachineLinkItems(
    familyId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/{familyId}/Machine/LinkItems',
      path: {
        familyId: familyId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to link dealer fit items to family
   * @param familyId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static familyFamilyIdMachineLinkDealerFits(
    familyId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/{familyId}/Machine/LinkDealerFits',
      path: {
        familyId: familyId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get unassigned attachment base units
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyAttachmentBaseUnitUnassigned(): CancelablePromise<
    Array<FamilyItemDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Family/Attachment/BaseUnit/Unassigned'
    })
  }

  /**
   * Method allows you to get unassigned attachment factory fit options
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyAttachmentFactoryFitUnassigned(): CancelablePromise<
    Array<FamilyItemDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Family/Attachment/FactoryFit/Unassigned'
    })
  }

  /**
   * Method allows you to get unassigned attachment dealer fit options
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyAttachmentDealerFitUnassigned(): CancelablePromise<
    Array<FamilyItemDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Family/Attachment/DealerFit/Unassigned'
    })
  }

  /**
   * Method allows you to receive attachment items without family
   * @param requestBody
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyAttachmentBaseUnitUnassignedPost(
    requestBody: Array<number>
  ): CancelablePromise<Array<FamilyItemDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/Attachment/BaseUnit/UnassignedPost',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to receive attachment items without family
   * @param requestBody
   * @returns FamilyItemDto OK
   * @throws ApiError
   */
  public static familyAttachmentFactoryFitUnassignedPost(
    requestBody: Array<number>
  ): CancelablePromise<Array<FamilyItemDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/Attachment/FactoryFit/UnassignedPost',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get families with attachment base unit factory options
   * @returns FullFamilyDto OK
   * @throws ApiError
   */
  public static familiesAttachmentBaseUnits(): CancelablePromise<
    Array<FullFamilyDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Families/Attachment/BaseUnits'
    })
  }

  /**
   * Method allows you to get families with attachment factory fit options
   * @returns FullFamilyDto OK
   * @throws ApiError
   */
  public static familiesAttachmentFactoryFits(): CancelablePromise<
    Array<FullFamilyDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Families/Attachment/FactoryFits'
    })
  }

  /**
   * Method allows you to get families with attachment dealer fit options
   * @returns FullFamilyDto OK
   * @throws ApiError
   */
  public static familiesAttachmentDealerFits(): CancelablePromise<
    Array<FullFamilyDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Families/Attachment/DealerFits'
    })
  }

  /**
   * Method allows you to delete factory attachment items from family
   * @param familyId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static familyFamilyIdAttachmentUnlinkItems(
    familyId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/{familyId}/Attachment/UnlinkItems',
      path: {
        familyId: familyId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete dealer fits attachment items from family
   * @param familyId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static familyFamilyIdAttachmentUnlinkDealerFits(
    familyId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/{familyId}/Attachment/UnlinkDealerFits',
      path: {
        familyId: familyId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to link factory attachment items to family
   * @param familyId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static familyFamilyIdAttachmentLinkItems(
    familyId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/{familyId}/Attachment/LinkItems',
      path: {
        familyId: familyId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to link dealer fits attachment items to family
   * @param familyId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static familyFamilyIdAttachmentLinkDealerFits(
    familyId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Family/{familyId}/Attachment/LinkDealerFits',
      path: {
        familyId: familyId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to add machine Group
   * @param requestBody
   * @returns GroupDto OK
   * @throws ApiError
   */
  public static groupAddMachine(
    requestBody: AddGroupDto
  ): CancelablePromise<GroupDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Machine',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to add attachment Group
   * @param requestBody
   * @returns GroupDto OK
   * @throws ApiError
   */
  public static groupAddAttachment(
    requestBody: AddGroupDto
  ): CancelablePromise<GroupDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Attachment',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete a group by id
   * @param id
   * @returns any OK
   * @throws ApiError
   */
  public static groupsDelete(id: number): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Group',
      query: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to rename a group
   * @param id
   * @param name
   * @returns GroupDto OK
   * @throws ApiError
   */
  public static groupName(
    id: number,
    name: string
  ): CancelablePromise<GroupDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Group/Name',
      query: {
        id: id,
        name: name
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get groups with base unit factory fit options
   * @returns FullGroupDto OK
   * @throws ApiError
   */
  public static groupsMachineFactoryFits(): CancelablePromise<
    Array<FullGroupDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Groups/Machine/FactoryFits'
    })
  }

  /**
   * Method allows you to get groups with dealer fit options
   * @param withArchived
   * @returns FullGroupDto OK
   * @throws ApiError
   */
  public static groupsMachineDealerFits(
    withArchived?: boolean
  ): CancelablePromise<Array<FullGroupDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Groups/Machine/DealerFits',
      query: {
        withArchived: withArchived
      }
    })
  }

  /**
   * Method allows you to link factory machine item to group
   * @param groupId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static groupMachineAddFactoryFitsToGroup(
    groupId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Machine/AddFactoryFitsToGroup',
      query: {
        groupId: groupId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to link dealer fit items to group
   * @param groupId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static groupMachineAddDealerFitsToGroup(
    groupId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Machine/AddDealerFitsToGroup',
      query: {
        groupId: groupId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete factory machine items from Group
   * @param groupId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static groupMachineRemoveFactoryFitsFromGroup(
    groupId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Machine/RemoveFactoryFitsFromGroup',
      query: {
        groupId: groupId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete dealer fits from group
   * @param groupId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static groupMachineRemoveDealerFitsFromGroup(
    groupId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Machine/RemoveDealerFitsFromGroup',
      query: {
        groupId: groupId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get groups with attachment factory fit options
   * @returns FullGroupDto OK
   * @throws ApiError
   */
  public static groupsAttachmentFactoryFits(): CancelablePromise<
    Array<FullGroupDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Groups/Attachment/FactoryFits'
    })
  }

  /**
   * Method allows you to get groups with attachment dealer fit options
   * @returns FullGroupDto OK
   * @throws ApiError
   */
  public static groupsAttachmentDealerFits(): CancelablePromise<
    Array<FullGroupDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Groups/Attachment/DealerFits'
    })
  }

  /**
   * Method allows you to link attachment factory fit item to group
   * @param groupId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static groupAttachmentAddFactoryFitsToGroup(
    groupId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Attachment/AddFactoryFitsToGroup',
      query: {
        groupId: groupId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to link attachment dealer fit items to group
   * @param groupId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static groupAttachmentAddDealerFitsToGroup(
    groupId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Attachment/AddDealerFitsToGroup',
      query: {
        groupId: groupId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete factory attachment items from Group
   * @param groupId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static groupAttachmentRemoveFactoryFitsFromGroup(
    groupId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Attachment/RemoveFactoryFitsFromGroup',
      query: {
        groupId: groupId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to delete attachment dealer fits from group
   * @param groupId
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static groupAttachmentRemoveDealerFitsFromGroup(
    groupId: number,
    requestBody: Array<number>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Group/Attachment/RemoveDealerFitsFromGroup',
      query: {
        groupId: groupId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to receive list of VAT
   * @returns VatDto OK
   * @throws ApiError
   */
  public static vatAll(): CancelablePromise<Array<VatDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/VAT/all',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method returns active VAT
   * @returns VatDto OK
   * @throws ApiError
   */
  public static vatActive(): CancelablePromise<VatDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/VAT/active',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method returns next VAT
   * @returns VatDto OK
   * @throws ApiError
   */
  public static vatNext(): CancelablePromise<VatDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/VAT/next',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create VAT
   * @param requestBody
   * @returns VatDto OK
   * @throws ApiError
   */
  public static vatCreate(
    requestBody: CreateVatDto
  ): CancelablePromise<VatDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/VAT/create',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update VAT
   * @param requestBody
   * @returns VatDto OK
   * @throws ApiError
   */
  public static vatUpdate(requestBody: VatDto): CancelablePromise<VatDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/VAT/update',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add machine rule
   * @param requestBody
   * @returns FullMachineRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleMachinesAdd(
    requestBody: SaveMachineRuleDto
  ): CancelablePromise<FullMachineRuleDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ConfigurationRules/Machines',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get machine rules list
   * @returns ListMachineRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleMachinesGetList(): CancelablePromise<
    Array<ListMachineRuleDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Machines'
    })
  }

  /**
   * Method allows you to update machine rule
   * @param ruleId
   * @param requestBody
   * @returns FullMachineRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleMachinesUpdate(
    ruleId: number,
    requestBody: SaveMachineRuleDto
  ): CancelablePromise<FullMachineRuleDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/ConfigurationRules/Machines/{ruleId}',
      path: {
        ruleId: ruleId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get machine rule by id
   * @param ruleId
   * @returns FullMachineRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleMachinesGetById(
    ruleId: number
  ): CancelablePromise<FullMachineRuleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Machines/{ruleId}',
      path: {
        ruleId: ruleId
      }
    })
  }

  /**
   * Method allows you to delete machine rule by id
   * @param ruleId
   * @returns any OK
   * @throws ApiError
   */
  public static configurationRuleMachinesDeleteById(
    ruleId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/ConfigurationRules/Machines/{ruleId}',
      path: {
        ruleId: ruleId
      }
    })
  }

  /**
   * Method allows you to export all machine configuration rules to an Excel file
   * @returns binary OK
   * @throws ApiError
   */
  public static configurationRuleMachinesExportExcel(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Machines/Excel'
    })
  }

  /**
   * Get all associated machines by brand
   * @param brandId
   * @param filtered
   * @param ruleId
   * @returns BrandMachineItemDto OK
   * @throws ApiError
   */
  public static configurationRulesAssociatedMachinesBrandId(
    brandId: number,
    filtered: boolean,
    ruleId?: number
  ): CancelablePromise<Array<BrandMachineItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/AssociatedMachines/{brandId}',
      path: {
        brandId: brandId
      },
      query: {
        filtered: filtered,
        ruleId: ruleId
      }
    })
  }

  /**
   * Method allows you to get available machine items
   * @param machineId
   * @param withArchived
   * @returns MachineItemDto OK
   * @throws ApiError
   */
  public static configurationRuleMachineItems(
    machineId: number,
    withArchived?: boolean
  ): CancelablePromise<Array<MachineItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/MachineItems',
      query: {
        machineId: machineId,
        withArchived: withArchived
      }
    })
  }

  /**
   * Method allows you get machine id's supported rule
   * @param ruleId
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static configurationRulesCheckMachines(
    ruleId: number,
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ConfigurationRules/ValidateMachines',
      query: {
        ruleId: ruleId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get rules and machines after import
   * @param machineIds
   * @returns RulesByMachinesDto OK
   * @throws ApiError
   */
  public static configurationRuleMachinesGetPostImportConfiguration(
    machineIds: Array<number>
  ): CancelablePromise<RulesByMachinesDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Machines/GetPostImportConfiguration',
      query: {
        machineIds: machineIds
      }
    })
  }

  /**
   * Method allows you to add attachment rule
   * @param requestBody
   * @returns FullAttachmentRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentsAdd(
    requestBody: SaveAttachmentRuleDto
  ): CancelablePromise<FullAttachmentRuleDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ConfigurationRules/Attachments',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get attachments rules list
   * @returns ListMachineRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentsGetList(): CancelablePromise<
    Array<ListMachineRuleDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Attachments'
    })
  }

  /**
   * Method allows you to update attachment rule
   * @param ruleId
   * @param requestBody
   * @returns FullAttachmentRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentsUpdate(
    ruleId: number,
    requestBody: SaveAttachmentRuleDto
  ): CancelablePromise<FullAttachmentRuleDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/ConfigurationRules/Attachments/{ruleId}',
      path: {
        ruleId: ruleId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get attachment rule by id
   * @param ruleId
   * @returns FullAttachmentRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentsGetById(
    ruleId: number
  ): CancelablePromise<FullAttachmentRuleDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Attachments/{ruleId}',
      path: {
        ruleId: ruleId
      }
    })
  }

  /**
   * Method allows you to delete attachment rule by id
   * @param ruleId
   * @returns any OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentsDeleteById(
    ruleId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/ConfigurationRules/Attachments/{ruleId}',
      path: {
        ruleId: ruleId
      }
    })
  }

  /**
   * Method allows you to receive machine attachments by brand
   * @param brandId
   * @param filtered
   * @param ruleId
   * @returns BrandMachineAttachmentItemDto OK
   * @throws ApiError
   */
  public static configurationRulesAttachmentsBrandId(
    brandId: number,
    filtered: boolean,
    ruleId?: number
  ): CancelablePromise<Array<BrandMachineAttachmentItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/AssociatedAttachments/{brandId}',
      path: {
        brandId: brandId
      },
      query: {
        filtered: filtered,
        ruleId: ruleId
      }
    })
  }

  /**
   * Method allows you to get attachments rules list
   * @returns ListMachineRuleDto OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentsGetListTable(): CancelablePromise<
    Array<ListMachineRuleDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/AttachmentsTable'
    })
  }

  /**
   * Method allows you to export all attachment configuration rules to an Excel file
   * @returns binary OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentsExportExcel(): CancelablePromise<Blob> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Attachments/Excel'
    })
  }

  /**
   * Method allows you to get available attachment items
   * @param attachmentId
   * @param withArchived
   * @returns AttachmentItemDto OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentItems(
    attachmentId: number,
    withArchived?: boolean
  ): CancelablePromise<Array<AttachmentItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/AttachmentItems',
      query: {
        attachmentId: attachmentId,
        withArchived: withArchived
      }
    })
  }

  /**
   * Method allows you to get machine attachment id's rule
   * @param ruleId
   * @param requestBody
   * @returns number OK
   * @throws ApiError
   */
  public static configurationRulesValidateMachinesAttachments(
    ruleId: number,
    requestBody: Array<number>
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ConfigurationRules/ValidateMachinesAttachments',
      query: {
        ruleId: ruleId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get applicable attachment rules by item
   * @param attachmentId
   * @param itemName
   * @param itemType
   * @returns ConfigurationRuleGroupDto OK
   * @throws ApiError
   */
  public static configurationRuleGetApplicableAttachmentRules(
    attachmentId: number,
    itemName: string,
    itemType: string
  ): CancelablePromise<Array<ConfigurationRuleGroupDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Attachments/GetApplicableRules',
      query: {
        attachmentId: attachmentId,
        itemName: itemName,
        itemType: itemType
      }
    })
  }

  /**
   * Method allows you to get rules and attachments after import
   * @param attachmentIds
   * @returns RulesByAttachmentsDto OK
   * @throws ApiError
   */
  public static configurationRuleAttachmentsGetPostImportConfiguration(
    attachmentIds: Array<number>
  ): CancelablePromise<RulesByAttachmentsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/ConfigurationRules/Attachments/GetPostImportConfiguration',
      query: {
        attachmentIds: attachmentIds
      }
    })
  }

  /**
   * Method allows you to update Rule valid state for all rules
   * @returns number OK
   * @throws ApiError
   */
  public static configurationRulesUpdateAllRulesValidState(): CancelablePromise<
    Array<number>
  > {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/ConfigurationRules/UpdateAllRulesValidState'
    })
  }

  /**
   * Method allows you to receive list of Trade In Manufacturers
   * @returns TradeInManufacturerDto OK
   * @throws ApiError
   */
  public static tradeInAllManufacturers(): CancelablePromise<
    Array<TradeInManufacturerDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/TradeIn/AllManufacturers',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create Trade In Manufacturer
   * @param requestBody
   * @returns TradeInManufacturerDto Created
   * @throws ApiError
   */
  public static tradeInAddManufacturer(
    requestBody: TradeInManufacturerDto
  ): CancelablePromise<TradeInManufacturerDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/TradeIn/AddManufacturer',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Get QuotationMetadata table
   * @returns QuotationMetatadaTableDto OK
   * @throws ApiError
   */
  public static quotationMetadataTable(): CancelablePromise<
    Array<QuotationMetatadaTableDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/QuotationMetadata/Table'
    })
  }

  /**
   * Get QuotationMetadata my table
   * @returns QuotationMetatadaTableDto OK
   * @throws ApiError
   */
  public static quotationMetadataMyTable(): CancelablePromise<
    Array<QuotationMetatadaTableDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/QuotationMetadata/My/Table'
    })
  }

  /**
   * Get QuotationMetadata my table
   * @returns QuotationMetatadaTableDto OK
   * @throws ApiError
   */
  public static quotationMetadataMyAll(): CancelablePromise<
    Array<QuotationMetatadaTableDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/QuotationMetadata/My/All'
    })
  }

  /**
   * Method allows you to rebuild QuotationMetadata table
   * @param tenant
   * @returns any OK
   * @throws ApiError
   */
  public static rebuildQuotationMetadata(
    tenant: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Rebuild/QuotationMetadata',
      query: {
        tenant: tenant
      }
    })
  }

  /**
   * Method allows you to see progress
   * @returns any OK
   * @throws ApiError
   */
  public static rebuildQuotationMetadataState(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Rebuild/GetQuotationMetadataRebuildProgress'
    })
  }

  /**
   * Get QuotationHistory table
   * @param id
   * @returns QuotationHistory OK
   * @throws ApiError
   */
  public static quotationHistoryId(
    id: string
  ): CancelablePromise<Array<QuotationHistory>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/QuotationHistory',
      query: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get Stock items by id list
   * @param requestBody
   * @returns StockDto OK
   * @throws ApiError
   */
  public static getStocksByIdsInternal(
    requestBody: IdsTenantEventData
  ): CancelablePromise<StockDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/Stocks',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get Stock items by unitNumbers list
   * @param requestBody
   * @returns StockDto OK
   * @throws ApiError
   */
  public static getStocksByunitNumberss(
    requestBody: IdsTenantEventStringData
  ): CancelablePromise<StockDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/Stocks/UnitNumber',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * @returns any OK
   * @throws ApiError
   */
  public static createOrUpdateStocksInDb(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Stocks/CreateOrUpdateStocks',
      errors: {
        400: `Bad Request`,
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get list of stocks with LCC
   * @returns StockLifeCycleCostDto OK
   * @throws ApiError
   */
  public static stocksGetLifeCycleCosting(): CancelablePromise<
    Array<StockLifeCycleCostDto>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/LifeCycleCosting'
    })
  }

  /**
   * Method allows you to set the stock to use LCC
   * @param id
   * @returns any OK
   * @throws ApiError
   */
  public static stocksLifeCycleCostingIdPost(
    id: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Stocks/LifeCycleCosting/{id}',
      path: {
        id: id
      },
      errors: {
        400: `Bad Request`
      }
    })
  }

  /**
   * Method allows you to set the stock not to use LCC
   * @param id
   * @returns any OK
   * @throws ApiError
   */
  public static stocksLifeCycleCostingIdDelete(
    id: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Stocks/LifeCycleCosting/{id}',
      path: {
        id: id
      },
      errors: {
        400: `Bad Request`
      }
    })
  }

  /**
   * Method allows you to get list of stock with/without status
   * @param inStock
   * @returns StockDataDto OK
   * @throws ApiError
   */
  public static stocksGetStocks(
    inStock: boolean
  ): CancelablePromise<Array<StockDataDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/GetStocks',
      query: {
        inStock: inStock
      }
    })
  }

  /**
   * Method allows you to get Stock item
   * @param id
   * @returns StockDto OK
   * @throws ApiError
   */
  public static stocksId(id: number): CancelablePromise<StockDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/{id}',
      path: {
        id: id
      }
    })
  }

  /**
   * Method allows you to get Stock items by id list
   * @param requestBody
   * @returns StockDto OK
   * @throws ApiError
   */
  public static getStocksByIds(
    requestBody: Array<number>
  ): CancelablePromise<StockDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Stocks',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to get stock brand machines
   * @param brandId
   * @returns StockMachineDto OK
   * @throws ApiError
   */
  public static stocksGetMachinesByBrandId(
    brandId: number
  ): CancelablePromise<Array<StockMachineDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/Brand/Machines',
      query: {
        brandId: brandId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get brand MachineAttachments
   * @param brandId
   * @param tonnage
   * @returns StockMachineAttachmentDto OK
   * @throws ApiError
   */
  public static stocksGetMachineAttachmentsByBrandId(
    brandId: number,
    tonnage?: number
  ): CancelablePromise<Array<StockMachineAttachmentDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/Brand/MachineAttachments',
      query: {
        brandId: brandId,
        tonnage: tonnage
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get stocks for machine
   * @param machineId
   * @param stockStatus
   * @returns StockMachineDataDto OK
   * @throws ApiError
   */
  public static stocksGetStocksByMachineId(
    machineId: number,
    stockStatus: string
  ): CancelablePromise<Array<StockMachineDataDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/MachineStocks/{machineId}',
      path: {
        machineId: machineId
      },
      query: {
        stockStatus: stockStatus
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to find machine for current quotation replacement
   * @param machineId
   * @returns StockMachineDataDto OK
   * @throws ApiError
   */
  public static stocksMachinesReplacement(
    machineId: number
  ): CancelablePromise<Array<StockMachineDataDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/MachinesReplacement/{machineId}',
      path: {
        machineId: machineId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allow you to find attachments for current quotation replacement
   * @param attachmentId
   * @returns StockMachineAttachmentDataDto OK
   * @throws ApiError
   */
  public static stocksAttachmentReplacement(
    attachmentId: number
  ): CancelablePromise<Array<StockMachineAttachmentDataDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/AttachmentReplacement/{attachmentId}',
      path: {
        attachmentId: attachmentId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get stocks for machine attachment
   * @param machineAttachmentId
   * @param stockStatus
   * @returns StockMachineAttachmentDataDto OK
   * @throws ApiError
   */
  public static stocksGetStocksByMachineAttachmentId(
    machineAttachmentId: number,
    stockStatus: string
  ): CancelablePromise<Array<StockMachineAttachmentDataDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/MachineAttachmentStocks/{machineAttachmentId}',
      path: {
        machineAttachmentId: machineAttachmentId
      },
      query: {
        stockStatus: stockStatus
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get priced stocks list for machine by status
   * @param machineId
   * @param status
   * @returns EquipmentListItem OK
   * @throws ApiError
   */
  public static stocksGetStocksListByMachineAsync(
    machineId: number,
    status: string
  ): CancelablePromise<Array<EquipmentListItem>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/Machines/{machineId}',
      path: {
        machineId: machineId
      },
      query: {
        status: status
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get priced stocks list for attachment by status
   * @param attachmentId
   * @param status
   * @returns EquipmentListItem OK
   * @throws ApiError
   */
  public static stocksGetStocksListByAttachmentAsync(
    attachmentId: number,
    status: string
  ): CancelablePromise<Array<EquipmentListItem>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/Attachments/{attachmentId}',
      path: {
        attachmentId: attachmentId
      },
      query: {
        status: status
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get stocks list by brand and equipment parameters
   * @param brandId
   * @param modelName
   * @param manufactureYear
   * @param status
   * @returns EquipmentListItemsWithMultipleQuotesDto OK
   * @throws ApiError
   */
  public static stocksGetStocksListByEquipmentParameters(
    brandId: number,
    modelName: string,
    manufactureYear: number,
    status: string
  ): CancelablePromise<EquipmentListItemsWithMultipleQuotesDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/Equipments',
      query: {
        brandId: brandId,
        modelName: modelName,
        manufactureYear: manufactureYear,
        status: status
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get count of stock not mapped to machine/attachment filtered by optional parameter brandId
   * @param brandId
   * @returns number OK
   * @throws ApiError
   */
  public static stocksUnallocatedCount(
    brandId?: number
  ): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Stocks/Unallocated/Count',
      query: {
        brandId: brandId
      }
    })
  }

  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static linkStocksToEquipment(
    requestBody: StockLinkingDto
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Stocks/Link',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to create Quotation
   * @param quotationId
   * @param customerId
   * @param quotationName
   * @param customerContactId
   * @param deliveryAddressId
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static createQuotation(
    quotationId: string,
    customerId: string,
    quotationName: string,
    customerContactId?: number,
    deliveryAddressId?: number
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateQuotation',
      query: {
        QuotationId: quotationId,
        CustomerId: customerId,
        CustomerContactId: customerContactId,
        deliveryAddressId: deliveryAddressId,
        QuotationName: quotationName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create Quotation with additional user name param
   * @param quotationId
   * @param customerId
   * @param userName
   * @param quotationName
   * @param customerContactId
   * @param deliveryAddressId
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static createQuotationBehalfOn(
    quotationId: string,
    customerId: string,
    userName: string,
    quotationName: string,
    customerContactId?: number,
    deliveryAddressId?: number
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CreateQuotationBehalfOn',
      query: {
        QuotationId: quotationId,
        CustomerId: customerId,
        CustomerContactId: customerContactId,
        deliveryAddressId: deliveryAddressId,
        UserName: userName,
        QuotationName: quotationName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get Quotation
   * @param id
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotation(id: string): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation',
      query: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get Quotation
   * @param id
   * @returns QuotationInfoDto OK
   * @throws ApiError
   */
  public static quotationInfo(id: string): CancelablePromise<QuotationInfoDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Internal/QuotationInfo',
      query: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get all Quotations
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static allQuotations(): CancelablePromise<Array<QuotationDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/AllQuotations',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get all Quotations filtered and paginated. Call "select {values} from c where {query} ORDER BY {оrderBy}"
   * @param requestBody
   * @returns GetQuotationPaginatedDto OK
   * @throws ApiError
   */
  public static allQuotationsPaginated(
    requestBody: PaginatedRequestContinueDto
  ): CancelablePromise<GetQuotationPaginatedDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/GetAllQuotationsPaginated',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to Count all Quotations Statues grouped by Status
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static countAllQuotationsStatuses(
    requestBody: Array<string>
  ): CancelablePromise<{
    Draft?: number
    DraftSentToCustomer?: number
    DraftAcceptedByCustomer?: number
    DraftRejectedByCustomer?: number
    DraftAcceptedOnBehalfOfCustomer?: number
    PendingLevel1Approval?: number
    PendingLevel2Approval?: number
    Level1ApprovedPendingLevel2Approval?: number
    Rejected_Internal_L1?: number
    Rejected_Internal_L2?: number
    Accepted?: number
    Price_changed?: number
    Needs_revising?: number
    Archived?: number
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CountAllQuotationsStatuses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get current user Quotations
   * @returns QuotationListDto OK
   * @throws ApiError
   */
  public static myQuotations(): CancelablePromise<Array<QuotationListDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/MyQuotations',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get current user Quotations filtered and paginated. Call "select {values} from c where c.UserName = 'user' and {query} ORDER BY {оrderBy}"
   * @param requestBody
   * @returns GetQuotationPaginatedDto OK
   * @throws ApiError
   */
  public static myQuotationsPaginated(
    requestBody: PaginatedRequestContinueDto
  ): CancelablePromise<GetQuotationPaginatedDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/MyQuotationsPaginated',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to Count current user Quotation Statues grouped by Status
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static countMyQuotationsStatuses(
    requestBody: Array<string>
  ): CancelablePromise<{
    Draft?: number
    DraftSentToCustomer?: number
    DraftAcceptedByCustomer?: number
    DraftRejectedByCustomer?: number
    DraftAcceptedOnBehalfOfCustomer?: number
    PendingLevel1Approval?: number
    PendingLevel2Approval?: number
    Level1ApprovedPendingLevel2Approval?: number
    Rejected_Internal_L1?: number
    Rejected_Internal_L2?: number
    Accepted?: number
    Price_changed?: number
    Needs_revising?: number
    Archived?: number
  }> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CountMyQuotationsStatuses',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get current user Quotations by customer
   * @param customerId
   * @returns QuotationListDto OK
   * @throws ApiError
   */
  public static myQuotationsByCustomer(
    customerId: number
  ): CancelablePromise<Array<QuotationListDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/MyQuotationsByCustomer',
      query: {
        customerId: customerId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get current user Quotations filtered and paginated. Call "select {values} from c where c.UserName = 'user' and c.CustomerId = 'customerId' and {query} ORDER BY {оrderBy}"
   * @param customerId
   * @param requestBody
   * @returns GetQuotationPaginatedDto OK
   * @throws ApiError
   */
  public static getMyQuotationsByCustomerPaginated(
    customerId: number,
    requestBody: PaginatedRequestContinueDto
  ): CancelablePromise<GetQuotationPaginatedDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/MyQuotationsByCustomer/{customerId}/Paginated',
      path: {
        customerId: customerId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get all Quotations by customer
   * @param customerId
   * @returns QuotationListDto OK
   * @throws ApiError
   */
  public static allQuotationsByCustomer(
    customerId: number
  ): CancelablePromise<Array<QuotationListDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/AllQuotationsByCustomer',
      query: {
        customerId: customerId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get All current user Quotations filtered and paginated. Call "select {values} from c where c.CustomerId = 'customerId' and {query} ORDER BY {оrderBy}"
   * @param customerId
   * @param requestBody
   * @returns GetQuotationPaginatedDto OK
   * @throws ApiError
   */
  public static getAllQuotationsByCustomerPaginated(
    customerId: number,
    requestBody: PaginatedRequestContinueDto
  ): CancelablePromise<GetQuotationPaginatedDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/AllQuotationsByCustomer/{customerId}/Paginated',
      path: {
        customerId: customerId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get QuotationSummaryInternalApprovalData
   * @param id
   * @returns QuotationSummaryInternalApprovalPdfDto OK
   * @throws ApiError
   */
  public static quotationSummaryInternalApprovalData(
    id: string
  ): CancelablePromise<QuotationSummaryInternalApprovalPdfDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Internal/QuotationSummaryInternalApprovalData',
      query: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get QuotationSummarySalesSupportData
   * @param id
   * @returns QuotationSummarySalesSupportDto OK
   * @throws ApiError
   */
  public static quotationSummarySalesSupportData(
    id: string
  ): CancelablePromise<QuotationSummarySalesSupportDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Internal/QuotationSummarySalesSupportData',
      query: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get all quotations metadata to rebuild
   * @param tenant
   * @returns QuotationMetadataUpdateDto OK
   * @throws ApiError
   */
  public static internalGetQuotationMetadataAsync(
    tenant: string
  ): CancelablePromise<Array<Array<QuotationMetadataUpdateDto>>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Internal/GetQuotationMetadataAsync',
      query: {
        tenant: tenant
      }
    })
  }

  /**
   * Method allows you to get QuotationSummaryCustomerQuoteData
   * @param id
   * @returns QuotationSummaryCustomerQuoteDto OK
   * @throws ApiError
   */
  public static quotationSummaryCustomerQuoteData(
    id: string
  ): CancelablePromise<QuotationSummaryCustomerQuoteDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Internal/QuotationSummaryCustomerQuoteData',
      query: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get Quotation
   * @param id
   * @returns QuotationMarginDto OK
   * @throws ApiError
   */
  public static quotationMargin(
    id: string
  ): CancelablePromise<QuotationMarginDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation/Margin',
      query: {
        id: id
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allow you to lock deal summary prices per quotation
   * @param id
   * @param lockPrice
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static quotationUpdatePriceLock(
    id: string,
    lockPrice: boolean
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/UpdatePriceLock',
      query: {
        id: id,
        lockPrice: lockPrice
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update Quotation name and contact id
   * @param quotationId
   * @param quotationName
   * @param customerId
   * @param customerContactId
   * @param deliveryAddressId
   * @param billingAddressId
   * @param quoteOwner
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationUpdateDetails(
    quotationId: string,
    quotationName: string,
    customerId?: string,
    customerContactId?: number,
    deliveryAddressId?: number,
    billingAddressId?: number,
    quoteOwner?: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/UpdateDetails',
      query: {
        quotationId: quotationId,
        quotationName: quotationName,
        customerId: customerId,
        customerContactId: customerContactId,
        deliveryAddressId: deliveryAddressId,
        billingAddressId: billingAddressId,
        quoteOwner: quoteOwner
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update Quotation name
   * @param quotationId
   * @param notes
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static quotationUpdateNotes(
    quotationId: string,
    notes: string
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/UpdateNotes',
      query: {
        quotationId: quotationId,
        notes: notes
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update prices in Quotation
   * @param requestBody
   * @param introToFinance
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationUpdatePrices(
    requestBody: QuotationSellPriceDto,
    introToFinance?: boolean
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/UpdateSellPrices',
      query: {
        introToFinance: introToFinance
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update prices in Quotation draft
   * @param itemId
   * @param requestBody
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationDraftUpdateSellPrices(
    itemId: string,
    requestBody: QuotationSellPriceDto
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Draft/UpdateSellPrices',
      query: {
        itemId: itemId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update quotation status
   * @param statusTo
   * @param requestBody
   * @returns any OK
   * @returns string Multi-Status
   * @throws ApiError
   */
  public static quotationUpdateStatus(
    statusTo: QuotationStatusEnum,
    requestBody: Array<string>
  ): CancelablePromise<any | Array<string>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/UpdateStatus',
      query: {
        statusTo: statusTo
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Unprocessable Content`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to update quotation status for Approvals
   * @param quotationId
   * @param statusTo
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationUpdateApprovalsFlowStatus(
    quotationId: string,
    statusTo: QuotationStatusEnum
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Internal/Quotation/UpdateApprovalsFlowStatus',
      query: {
        quotationId: quotationId,
        statusTo: statusTo
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update quotation status to Accepted
   * @param quotationId
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static internalQuotationAccept(
    quotationId: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/Quotation/Accept',
      query: {
        quotationId: quotationId
      },
      errors: {
        404: `Not Found`,
        409: `Conflict`,
        417: `Expectation Failed`
      }
    })
  }

  /**
   * Method allows you to reset and recalculate quotation status
   * @param requestBody
   * @returns QuotationUpdateDto OK
   * @returns string Multi-Status
   * @throws ApiError
   */
  public static quotationReturnToDraft(
    requestBody: Array<string>
  ): CancelablePromise<Array<QuotationUpdateDto> | Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/ReturnToDraft',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to reset and recalculate quotation status for single quote
   * @param quotationId
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static internalQuotationReturnToDraftSingle(
    quotationId: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/Quotation/ReturnToDraftSingle',
      query: {
        quotationId: quotationId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows updates the prices of the quotation
   * @param quotationId
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationUpdateQuotationPrices(
    quotationId: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/UpdateQuotationPrices',
      query: {
        quotationId: quotationId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add machine to Quotation
   * @param quotationId
   * @param machineId
   * @returns MachineQuotationItemDto OK
   * @throws ApiError
   */
  public static quotationAddMachine(
    quotationId: string,
    machineId: number
  ): CancelablePromise<MachineQuotationItemDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/AddMachine',
      query: {
        quotationId: quotationId,
        machineId: machineId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete machine from Quotation
   * @param quotationId
   * @param machineItemId
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationDeleteMachine(
    quotationId: string,
    machineItemId: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/Machine',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add StockItem to Quotation
   * @param quotationId
   * @param stockItemId
   * @returns string OK
   * @throws ApiError
   */
  public static quotationAddStockItem(
    quotationId: string,
    stockItemId: number
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/StockItem',
      query: {
        quotationId: quotationId,
        stockItemId: stockItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to replace StockItem in Quotation and create copy in cache
   * @param quotationId
   * @param quotationItemId
   * @param stockItemId
   * @returns string OK
   * @throws ApiError
   */
  public static quotationReplaceStockItem(
    quotationId: string,
    quotationItemId: string,
    stockItemId: number
  ): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/StockItem',
      query: {
        quotationId: quotationId,
        quotationItemId: quotationItemId,
        stockItemId: stockItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update the order of a quotation item
   * @param quotationId
   * @param itemId
   * @param toIndex
   * @returns QuotationItemOrderDto OK
   * @throws ApiError
   */
  public static quotationReorderItem(
    quotationId: string,
    itemId: string,
    toIndex: number
  ): CancelablePromise<Array<QuotationItemOrderDto>> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/ReorderItem',
      query: {
        quotationId: quotationId,
        itemId: itemId,
        toIndex: toIndex
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add machine attachment to Quotation
   * @param quotationId
   * @param machineAttachmentId
   * @returns MachineAttachmentItemDto OK
   * @throws ApiError
   */
  public static quotationAddMachineAttachment(
    quotationId: string,
    machineAttachmentId: number
  ): CancelablePromise<MachineAttachmentItemDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/AddMachineAttachment',
      query: {
        quotationId: quotationId,
        machineAttachmentId: machineAttachmentId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete machine attachment from Quotation
   * @param quotationId
   * @param machineAttachmentId
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationDeleteMachineAttachment(
    quotationId: string,
    machineAttachmentId: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/MachineAttachment',
      query: {
        quotationId: quotationId,
        machineAttachmentId: machineAttachmentId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get Quotation Factory Support values by Quotation Id
   * @param quotationId
   * @returns QuotationFactorySupportValuesDto OK
   * @throws ApiError
   */
  public static quotationFactorySupportGetValues(
    quotationId: string
  ): CancelablePromise<QuotationFactorySupportValuesDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation/FactorySupport/Values',
      query: {
        quotationId: quotationId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save Quotation Factory Support values by Quotation Id
   * @param quotationId
   * @param requestBody
   * @returns QuotationFactorySupportValuesDto OK
   * @throws ApiError
   */
  public static quotationFactorySupportSaveValues(
    quotationId: string,
    requestBody: QuotationFactorySupportValuesDto
  ): CancelablePromise<QuotationFactorySupportValuesDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/FactorySupport/Values',
      query: {
        quotationId: quotationId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to receive preview quotation summary contract info
   * @param quotationId
   * @returns QuotationSummaryDto OK
   * @throws ApiError
   */
  public static quotationGetSummary(
    quotationId: string
  ): CancelablePromise<QuotationSummaryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation/GetSummary',
      query: {
        quotationId: quotationId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to send final approval to next flow
   * @param quotationId
   * @param quotationHash
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static quotationSendToApproval(
    quotationId: string,
    quotationHash: string,
    requestBody?: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/SendToApproval',
      query: {
        quotationId: quotationId,
        quotationHash: quotationHash
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to delete Quotation by Ids
   * @param requestBody
   * @returns any OK
   * @returns string Multi-Status
   * @throws ApiError
   */
  public static quotationsDelete(
    requestBody: Array<string>
  ): CancelablePromise<any | Array<string>> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotations',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
        409: `Conflict`
      }
    })
  }

  /**
   * Method allows you to add tradeIn to Quotation
   * @param quotationId
   * @param requestBody
   * @returns QuotationWithNewObjectIdDto OK
   * @throws ApiError
   */
  public static quotationAddTradeIn(
    quotationId: string,
    requestBody: TradeInItemDto
  ): CancelablePromise<QuotationWithNewObjectIdDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/AddTradeIn',
      query: {
        quotationId: quotationId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to edit tradeIn in Quotation
   * @param quotationId
   * @param tradeInItemId
   * @param requestBody
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationUpdateTradeIn(
    quotationId: string,
    tradeInItemId: string,
    requestBody: TradeInItemDto
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/UpdateTradeIn',
      query: {
        quotationId: quotationId,
        tradeInItemId: tradeInItemId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete tradeIn in Quotation
   * @param quotationId
   * @param tradeInItemId
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationDeleteTradeIn(
    quotationId: string,
    tradeInItemId: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/DeleteTradeIn',
      query: {
        quotationId: quotationId,
        tradeInItemId: tradeInItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get tradeIn types
   * @returns string OK
   * @throws ApiError
   */
  public static quotationTradeInTypes(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation/TradeInTypes',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to configure machine in Quotation
   * @param quotationId
   * @param itemId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineGetDraft(
    quotationId: string,
    itemId: string
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation/Machine/Draft',
      query: {
        quotationId: quotationId,
        itemId: itemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine configuration to Quotation
   * @param quotationId
   * @param itemId
   * @param updateToNewPriceSaving
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static quotationMachineSaveDraft(
    quotationId: string,
    itemId: string,
    updateToNewPriceSaving: boolean = false
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/Draft',
      query: {
        quotationId: quotationId,
        itemId: itemId,
        updateToNewPriceSaving: updateToNewPriceSaving
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to clear machine configuration from Quotation
   * @param itemId
   * @returns any OK
   * @throws ApiError
   */
  public static quotationMachineClearDraft(
    itemId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/Machine/Draft',
      query: {
        itemId: itemId
      }
    })
  }

  /**
   * Method allows you to add machine configuration to other Quotation
   * @param draftId
   * @param quotationId
   * @param itemId
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static quotationMachineSaveDraftDraftId(
    draftId: string,
    quotationId: string,
    itemId: string
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/Draft/{draftId}',
      path: {
        draftId: draftId
      },
      query: {
        quotationId: quotationId,
        itemId: itemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to copy machine in Quotation
   * @param quotationId
   * @param machineItemId
   * @returns MachineQuotationItemDto OK
   * @throws ApiError
   */
  public static quotationMachineCopy(
    quotationId: string,
    machineItemId: string
  ): CancelablePromise<MachineQuotationItemDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/Copy',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine quantity in Quotation
   * @param quotationId
   * @param machineItemId
   * @param quantity
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineUpdateQuantity(
    quotationId: string,
    machineItemId: string,
    quantity: number
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/UpdateQuantity',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        quantity: quantity
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine CRD in Quotation
   * @param quotationId
   * @param machineItemId
   * @param crd
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineUpdateCrd(
    quotationId: string,
    machineItemId: string,
    crd?: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/UpdateCRD',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        crd: crd
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine notes in Quotation
   * @param quotationId
   * @param machineItemId
   * @param notes
   * @returns MachineQuotationItemDto OK
   * @throws ApiError
   */
  public static quotationMachineUpdateNotes(
    quotationId: string,
    machineItemId: string,
    notes: string
  ): CancelablePromise<MachineQuotationItemDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/UpdateNotes',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        notes: notes
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allow you to update transport option in machine machine attachment
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param isOptionAvailable
   * @returns MachineQuotationItemDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentUpdateTransportAvailability(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    isOptionAvailable: boolean
  ): CancelablePromise<MachineQuotationItemDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/MachineAttachment/UpdateTransportAvailability',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        isOptionAvailable: isOptionAvailable
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add dealer option to Quotation
   * @param requestBody
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAddDealerFitOption(
    requestBody: AddMachineOptionDto
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/AddDealerFitOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to custom add dealer option to machine in Quotation
   * @param requestBody
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAddCustomDealerFitOptions(
    requestBody: CustomMachineFactoryAndDealerOptionDto
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/AddCustomDealerFitOptions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update custom dealer option to machine in Quotation
   * @param requestBody
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineUpdateCustomDealerFitOptions(
    requestBody: CustomMachineFactoryAndDealerOptionDto
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/UpdateCustomDealerFitOptions',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove dealer option from Quotation machine
   * @param quotationId
   * @param machineItemId
   * @param optionId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineRemoveDealerFitOption(
    quotationId: string,
    machineItemId: string,
    optionId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/RemoveDealerFitOption',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update quantity of dealer fit option quantity
   * @param quotationId
   * @param machineItemId
   * @param optionId
   * @param quantity
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineUpdateDealerFitOptionQuantity(
    quotationId: string,
    machineItemId: string,
    optionId: number,
    quantity: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/UpdateDealerFitOptionQuantity',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        optionId: optionId,
        quantity: quantity
      },
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to add factory option to machine in Quotation
   * @param requestBody
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAddFactoryOption(
    requestBody: AddMachineOptionDto
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/AddFactoryOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add custom factory option for machine in quotation without rules
   * @param requestBody
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAddCustomFactoryOption(
    requestBody: CustomMachineFactoryAndDealerOptionDto
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/AddCustomFactoryOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update custom factory option for machine in quotation without rules
   * @param requestBody
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineUpdateCustomFactoryOption(
    requestBody: CustomMachineFactoryAndDealerOptionDto
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/UpdateCustomFactoryOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove factory option to machine in Quotation
   * @param quotationId
   * @param machineItemId
   * @param optionId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineRemoveFactoryOption(
    quotationId: string,
    machineItemId: string,
    optionId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/RemoveFactoryOption',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add MachineAttachment to machine in Quotation
   * @param quotationId
   * @param machineItemId
   * @param attachmentId
   * @returns MachineAttachmentItemDto OK
   * @throws ApiError
   */
  public static quotationMachineAddMachineAttachment(
    quotationId: string,
    machineItemId: string,
    attachmentId: number
  ): CancelablePromise<MachineAttachmentItemDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/AddMachineAttachment',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        attachmentId: attachmentId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove MachineAttachment from machine in Quotation
   * @param quotationId
   * @param machineItemId
   * @param attachmentItemId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineRemoveMachineAttachment(
    quotationId: string,
    machineItemId: string,
    attachmentItemId: string
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/RemoveMachineAttachment',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        attachmentItemId: attachmentItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add warranty into machine in Quotation
   * @param quotationId
   * @param machineItemId
   * @param warrantyId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAddWarranty(
    quotationId: string,
    machineItemId: string,
    warrantyId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/AddWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove warranty from machine in Quotation
   * @param quotationId
   * @param machineItemId
   * @param warrantyId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineRemoveWarranty(
    quotationId: string,
    machineItemId: string,
    warrantyId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/RemoveWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add brand warranty into machine in Quotation
   * @param quotationId
   * @param machineItemId
   * @param warrantyId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineBrandWarranty(
    quotationId: string,
    machineItemId: string,
    warrantyId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/BrandWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove brand warranty from machine in quotation
   * @param quotationId
   * @param machineItemId
   * @param warrantyId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineBrandWarranty1(
    quotationId: string,
    machineItemId: string,
    warrantyId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/Machine/BrandWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get brand warranty price for quotation item in Quotation
   * @param quotationId
   * @param quotationItemId
   * @returns BrandWarrantyQuotationItemDto OK
   * @throws ApiError
   */
  public static quotationItemBrandWarrantyPrices(
    quotationId: string,
    quotationItemId: string
  ): CancelablePromise<Array<BrandWarrantyQuotationItemDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation/Item/BrandWarranty/Prices',
      query: {
        quotationId: quotationId,
        quotationItemId: quotationItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add transport option in quotation
   * @param quotationId
   * @param machineItemId
   * @param transportOptionId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAddTransportOption(
    quotationId: string,
    machineItemId: string,
    transportOptionId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/AddTransportOption',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        transportOptionId: transportOptionId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove transport option from machine in Quotation
   * @param quotationId
   * @param machineItemId
   * @param transportOptionId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineRemoveTransportOption(
    quotationId: string,
    machineItemId: string,
    transportOptionId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/RemoveTransportOption',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        transportOptionId: transportOptionId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add service contract for machine in quotation
   * @param quotationId
   * @param machineItemId
   * @param serviceContractId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAddServiceContract(
    quotationId: string,
    machineItemId: string,
    serviceContractId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/AddServiceContract',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        serviceContractId: serviceContractId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add service contract for machine in quotation
   * @param quotationId
   * @param machineItemId
   * @param serviceContractId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineRemoveServiceContract(
    quotationId: string,
    machineItemId: string,
    serviceContractId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/RemoveServiceContract',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        serviceContractId: serviceContractId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to configure machine attachment in Quotation
   * @param quotationId
   * @param itemId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentGetDraft(
    quotationId: string,
    itemId: string
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation/MachineAttachment/Draft',
      query: {
        quotationId: quotationId,
        itemId: itemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine attachment configuration to Quotation
   * @param quotationId
   * @param itemId
   * @param updateToNewPriceSaving
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentSaveDraft(
    quotationId: string,
    itemId: string,
    updateToNewPriceSaving: boolean = false
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/Draft',
      query: {
        quotationId: quotationId,
        itemId: itemId,
        updateToNewPriceSaving: updateToNewPriceSaving
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to clear machine attachment configuration from Quotation
   * @param itemId
   * @returns any OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentClearDraft(
    itemId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/MachineAttachment/Draft',
      query: {
        itemId: itemId
      }
    })
  }

  /**
   * Method allows you to add machine attachment configuration to Quotation
   * @param draftId
   * @param quotationId
   * @param itemId
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentAddDraft(
    draftId: string,
    quotationId: string,
    itemId: string
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/MachineAttachment/Draft/{draftId}',
      path: {
        draftId: draftId
      },
      query: {
        quotationId: quotationId,
        itemId: itemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to copy machine attachment in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @returns MachineAttachmentItemDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentCopy(
    quotationId: string,
    attachmentItemId: string
  ): CancelablePromise<MachineAttachmentItemDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/Copy',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine attachment quantity in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param quantity
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentUpdateQuantity(
    quotationId: string,
    attachmentItemId: string,
    quantity: number
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/UpdateQuantity',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        quantity: quantity
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine attachment CRD in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param crd
   * @returns QuotationUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentUpdateCrd(
    quotationId: string,
    attachmentItemId: string,
    crd?: string
  ): CancelablePromise<QuotationUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/UpdateCRD',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        crd: crd
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update MachineAttachment notes in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param notes
   * @returns MachineAttachmentItemDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentUpdateNotes(
    quotationId: string,
    attachmentItemId: string,
    notes: string
  ): CancelablePromise<MachineAttachmentItemDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/UpdateNotes',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        notes: notes
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add custom factory option item into machine attachment in quotation
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentAddCustomFactoryOption(
    requestBody: CustomMachineAttachmentFactoryAndDealerOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/MachineAttachment/AddCustomFactoryOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update custom factory option for machine attachment in quotation without rules
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentUpdateCustomFactoryOption(
    requestBody: CustomMachineAttachmentFactoryAndDealerOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/MachineAttachment/UpdateCustomFactoryOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add factory option to machine attachment in Quotation
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentAddFactoryOption(
    requestBody: AddMachineOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/AddFactoryOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove factory option from machine attachment in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentRemoveFactoryOption(
    quotationId: string,
    attachmentItemId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/RemoveFactoryOption',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add custom dealer option item into machine attachment in quotation
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentAddCustomDealerOption(
    requestBody: CustomMachineAttachmentFactoryAndDealerOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/MachineAttachment/AddCustomDealerOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update custom dealer option item for machine attachment in quotation
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentUpdateCustomDealerOption(
    requestBody: CustomMachineAttachmentFactoryAndDealerOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/UpdateCustomDealerOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add dealer option to Quotation machine attachment
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentAddDealerFitOption(
    requestBody: AddMachineOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/MachineAttachment/AddDealerFitOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update the dealer fit option quantity for Machine Attachments
   * @param quotationId
   * @param attachmentItemId
   * @param optionId
   * @param quantity
   * @param machineItemId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentUpdateDealerFitOptionQuantity(
    quotationId: string,
    attachmentItemId: string,
    optionId: number,
    quantity: number,
    machineItemId?: string
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/UpdateDealerFitOptionQuantity',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        attachmentItemId: attachmentItemId,
        optionId: optionId,
        quantity: quantity
      },
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to remove dealer fit option from machine attachment in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentRemoveDealerFitOption(
    quotationId: string,
    attachmentItemId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/RemoveDealerFitOption',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add warranty to machine attachment in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param warrantyId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentAddWarranty(
    quotationId: string,
    attachmentItemId: string,
    warrantyId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/AddWarranty',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove warranty from machine attachment in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param warrantyId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentRemoveWarranty(
    quotationId: string,
    attachmentItemId: string,
    warrantyId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/RemoveWarranty',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add brand warranty into machine attacment in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param warrantyId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentBrandWarranty(
    quotationId: string,
    attachmentItemId: string,
    warrantyId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/BrandWarranty',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove brand warranty from machine attachment in quotation
   * @param quotationId
   * @param machineItemId
   * @param brandWarrantyId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentBrandWarranty1(
    quotationId: string,
    machineItemId: string,
    brandWarrantyId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/MachineAttachment/BrandWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        brandWarrantyId: brandWarrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add Transport option to machine attachment in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentAddTransportOption(
    quotationId: string,
    attachmentItemId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/AddTransportOption',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove Transport option from machine attachment in Quotation
   * @param quotationId
   * @param attachmentItemId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineAttachmentRemoveTransportOption(
    quotationId: string,
    attachmentItemId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/MachineAttachment/RemoveTransportOption',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to configure machine/machine attachment in Machine
   * @param quotationId
   * @param machineItemId
   * @param attachmentItemId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentGetDraft(
    quotationId: string,
    machineItemId: string,
    attachmentItemId: string
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Quotation/Machine/MachineAttachment/Draft',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        attachmentItemId: attachmentItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine/machine attachment in Machine
   * @param quotationId
   * @param machineItemId
   * @param attachmentItemId
   * @param updateToNewPriceSaving
   * @returns MachineQuotationItemDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentSaveDraft(
    quotationId: string,
    machineItemId: string,
    attachmentItemId: string,
    updateToNewPriceSaving: boolean = false
  ): CancelablePromise<MachineQuotationItemDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/MachineAttachment/Draft',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        attachmentItemId: attachmentItemId,
        updateToNewPriceSaving: updateToNewPriceSaving
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine/machine attachment into stock
   * @param quotationId
   * @param machineItemId
   * @param stockItemId
   * @returns MachineAttachmentItemDto OK
   * @throws ApiError
   */
  public static quotationMachineAddMachineAttachmentStock(
    quotationId: string,
    machineItemId: string,
    stockItemId: number
  ): CancelablePromise<MachineAttachmentItemDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/AddMachineAttachment/Stock',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        stockItemId: stockItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine attachment notes for quotation machine
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param notes
   * @returns MachineAttachmentItemDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentUpdateNotes(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    notes: string
  ): CancelablePromise<MachineAttachmentItemDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/MachineAttachment/UpdateNotes',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        notes: notes
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine attachment quantity for quotation machine
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param quantity
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentUpdateQuantity(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    quantity: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/MachineAttachment/UpdateQuantity',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        quantity: quantity
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add warranty into machine attachment for quotation machine
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentAddWarranty(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/AddWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to remove warranty into machine attachment for quotation machine
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentRemoveWarranty(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/Machine/MachineAttachment/RemoveWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to add brand warranty into nested machine attacment in Quotation
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param warrantyId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentBrandWarranty(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    warrantyId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/MachineAttachment/BrandWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove brand warranty from machine attachment of a machine in quotation
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param warrantyId
   * @returns MachineQuotationItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentBrandWarranty1(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    warrantyId: number
  ): CancelablePromise<MachineQuotationItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Quotation/Machine/MachineAttachment/BrandWarranty',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        warrantyId: warrantyId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add transport options for machine attachment for quotation machine
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentItemId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentAddTransportOption(
    quotationId: string,
    machineItemId: string,
    machineAttachmentItemId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/AddTransportOption',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentItemId: machineAttachmentItemId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to add transport options for machine attachment for quotation machine
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentItemId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentRemoveTransportOption(
    quotationId: string,
    machineItemId: string,
    machineAttachmentItemId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/RemoveTransportOption',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentItemId: machineAttachmentItemId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to add factory fit options for machine attachment for quotation machine
   * @param machineAttachmentId
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentAddFactoryFitOption(
    machineAttachmentId: string,
    requestBody: AddMachineOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/AddFactoryFitOption',
      query: {
        machineAttachmentId: machineAttachmentId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to add custom factory option in machine attachment within machine for quotation
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentAddCustomFactoryOption(
    requestBody: CustomMachineMachineAttachmentFactoryAndDealerOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/AddCustomFactoryOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update custom factory fit options for machine attachment for quotation machine
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentUpdateCustomFactoryFitOption(
    requestBody: CustomMachineMachineAttachmentFactoryAndDealerOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/UpdateCustomFactoryFitOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove factory fit options for machine attachment for quotation machine
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentRemoveFactoryFitOption(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/RemoveFactoryFitOption',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to add dealer fit options for machine attachment for quotation machine
   * @param machineAttachmentId
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentAddDealerFitOption(
    machineAttachmentId: string,
    requestBody: AddMachineOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/AddDealerFitOption',
      query: {
        machineAttachmentId: machineAttachmentId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to remove dealer fit options for machine attachment for quotation machine
   * @param quotationId
   * @param machineItemId
   * @param machineAttachmentId
   * @param optionId
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentRemoveDealerFitOption(
    quotationId: string,
    machineItemId: string,
    machineAttachmentId: string,
    optionId: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/MachineAttachment/RemoveDealerFitOption',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        machineAttachmentId: machineAttachmentId,
        optionId: optionId
      },
      errors: {
        404: `Not Found`,
        500: `Internal Server Error`
      }
    })
  }

  /**
   * Method allows you to add custom dealer option in machine attachment within machine for quotation
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentAddCustomDealerOption(
    requestBody: CustomMachineMachineAttachmentFactoryAndDealerOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Quotation/Machine/MachineAttachment/AddCustomDealerOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update custom dealer option in machine attachment within machine for quotation
   * @param requestBody
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quotationMachineMachineAttachmentUpdateCustomDealerOption(
    requestBody: CustomMachineMachineAttachmentFactoryAndDealerOptionDto
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Quotation/Machine/MachineAttachment/UpdateCustomDealerOption',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to Get spec by id
   * @param specId
   * @param customerId
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static specSpec(
    specId: string,
    customerId: number
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Customers/{$customerId}/Specs/{$specId}',
      query: {
        specId: specId,
        customerId: customerId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to remove Spec by id
   * @param specId
   * @param customerId
   * @returns any OK
   * @throws ApiError
   */
  public static specRemoveSpecById(
    specId: string,
    customerId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Customers/{$customerId}/Specs/{$specId}',
      query: {
        specId: specId,
        customerId: customerId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get all specifications paginated
   * @param requestBody
   * @returns SpecificationPaginatedDto OK
   * @throws ApiError
   */
  public static customersGetAllSpecsPaginated(
    requestBody: PaginatedRequestContinueDto
  ): CancelablePromise<SpecificationPaginatedDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/Specs/Paginated',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to create new specification
   * @param customerId
   * @param specName
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static specAddSpec(
    customerId: number,
    specName: string
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/AddSpec',
      query: {
        customerId: customerId,
        specName: specName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add machine in quotation cache
   * @param specId
   * @param machineId
   * @returns MachineQuotationItemDto OK
   * @throws ApiError
   */
  public static specMachineSpecInCache(
    specId: string,
    machineId: number
  ): CancelablePromise<MachineQuotationItemDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Spec/MachineSpecInCache',
      query: {
        specId: specId,
        machineId: machineId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine to spec
   * @param quotationId
   * @param machineItemId
   * @param customerId
   * @param specName
   * @returns MachineTemplateDto OK
   * @throws ApiError
   */
  public static specSaveQuotationMachineItemToSpec(
    quotationId: string,
    machineItemId: string,
    customerId: number,
    specName: string
  ): CancelablePromise<MachineTemplateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Spec/SaveQuotationMachineItemToSpec',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        customerId: customerId,
        specName: specName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine draft to spec
   * @param quotationId
   * @param machineItemId
   * @param customerId
   * @param specName
   * @returns MachineTemplateDto OK
   * @throws ApiError
   */
  public static specSaveQuotationMachineItemEditedToSpec(
    quotationId: string,
    machineItemId: string,
    customerId: number,
    specName: string
  ): CancelablePromise<MachineTemplateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Spec/SaveQuotationMachineItemEditedToSpec',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        customerId: customerId,
        specName: specName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine attachment to spec
   * @param quotationId
   * @param attachmentItemId
   * @param customerId
   * @param specName
   * @returns AttachmentTemplateDto OK
   * @throws ApiError
   */
  public static specSaveQuotationMachineAttachmentItemToSpec(
    quotationId: string,
    attachmentItemId: string,
    customerId: number,
    specName: string
  ): CancelablePromise<AttachmentTemplateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Spec/SaveQuotationMachineAttachmentItemToSpec',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        customerId: customerId,
        specName: specName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine attachment draft to spec
   * @param quotationId
   * @param attachmentItemId
   * @param customerId
   * @param specName
   * @returns AttachmentTemplateDto OK
   * @throws ApiError
   */
  public static specSaveQuotationMachineAttachmentItemEditedToSpec(
    quotationId: string,
    attachmentItemId: string,
    customerId: number,
    specName: string
  ): CancelablePromise<AttachmentTemplateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Spec/SaveQuotationMachineAttachmentItemEditedToSpec',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        customerId: customerId,
        specName: specName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to save machine attachment in machine to spec
   * @param quotationId
   * @param attachmentItemId
   * @param customerId
   * @param specName
   * @param templateId
   * @returns MachineTemplateDto OK
   * @throws ApiError
   */
  public static specSaveQuotationMachineMachineAttachmentItemToSpec(
    quotationId: string,
    attachmentItemId: string,
    customerId: number,
    specName: string,
    templateId: string
  ): CancelablePromise<MachineTemplateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Spec/SaveQuotationMachineMachineAttachmentItemToSpec',
      query: {
        quotationId: quotationId,
        attachmentItemId: attachmentItemId,
        customerId: customerId,
        specName: specName,
        templateId: templateId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to add machine attachment in quotation cache
   * @param specId
   * @param attachmentId
   * @returns MachineAttachmentItemDto OK
   * @throws ApiError
   */
  public static specMachineAttachmentSpecInCache(
    specId: string,
    attachmentId: number
  ): CancelablePromise<MachineAttachmentItemDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Spec/MachineAttachmentSpecInCache',
      query: {
        specId: specId,
        attachmentId: attachmentId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update existing spec template
   * @param specId
   * @param customerId
   * @param templateId
   * @param quotationId
   * @param quotationItemId
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static customersUpdateSpecTemplate(
    specId: string,
    customerId: number,
    templateId: string,
    quotationId: string,
    quotationItemId: string
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}',
      query: {
        specId: specId,
        customerId: customerId,
        templateId: templateId,
        quotationId: quotationId,
        quotationItemId: quotationItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to delete existing spec template
   * @param specId
   * @param customerId
   * @param templateId
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static customersDeleteSpecTemplate(
    specId: string,
    customerId: number,
    templateId: string
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}',
      query: {
        specId: specId,
        customerId: customerId,
        templateId: templateId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Mathod allows you to receive template info by it's id and by spec id
   * @param customerId
   * @param specId
   * @param templateId
   * @returns MachineTemplateDto OK
   * @throws ApiError
   */
  public static customersGetSpecTemplate(
    customerId: number,
    specId: string,
    templateId: string
  ): CancelablePromise<MachineTemplateDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}',
      query: {
        customerId: customerId,
        specId: specId,
        templateId: templateId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update existing spec template
   * @param specId
   * @param customerId
   * @param templateId
   * @param quotationId
   * @param quotationItemId
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static customersUpdateSpecTemplateEdited(
    specId: string,
    customerId: number,
    templateId: string,
    quotationId: string,
    quotationItemId: string
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}/Edited',
      query: {
        specId: specId,
        customerId: customerId,
        templateId: templateId,
        quotationId: quotationId,
        quotationItemId: quotationItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine attachment template by id, spec id, template id
   * @param specId
   * @param customerId
   * @param templateId
   * @param attachmentId
   * @param quotationId
   * @param quotationItemId
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static customersUpdateMachineAttachmentInSpec(
    specId: string,
    customerId: number,
    templateId: string,
    attachmentId: string,
    quotationId: string,
    quotationItemId: string
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}/Attachments/{$attachmentId}',
      query: {
        specId: specId,
        customerId: customerId,
        templateId: templateId,
        attachmentId: attachmentId,
        quotationId: quotationId,
        quotationItemId: quotationItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update machine attachment template by id, spec id, template id
   * @param specId
   * @param customerId
   * @param templateId
   * @param attachmentId
   * @param quotationId
   * @param quotationItemId
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static customersUpdateMachineAttachmentInSpecEdited(
    specId: string,
    customerId: number,
    templateId: string,
    attachmentId: string,
    quotationId: string,
    quotationItemId: string
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}/Attachments/{$attachmentId}/Edited',
      query: {
        specId: specId,
        customerId: customerId,
        templateId: templateId,
        attachmentId: attachmentId,
        quotationId: quotationId,
        quotationItemId: quotationItemId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get all specifications by customer
   * @param customerId
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static customersGetAllSpecsByCustomer(
    customerId: number
  ): CancelablePromise<Array<SpecificationDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Customers/{$customerId}/Specs',
      query: {
        customerId: customerId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get all specifications by customer paginated
   * @param customerId
   * @param requestBody
   * @returns SpecificationPaginatedDto OK
   * @throws ApiError
   */
  public static customersGetAllSpecsByCustomerPaginated(
    customerId: number,
    requestBody: PaginatedRequestContinueDto
  ): CancelablePromise<SpecificationPaginatedDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/Paginated',
      query: {
        customerId: customerId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to Add Templates to Quotaton
   * @param specId
   * @param customerId
   * @param quotationId
   * @param requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static specAddTemplatesToQuotation(
    specId: string,
    customerId: number,
    quotationId: string,
    requestBody: Array<string>
  ): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/{$specId}/Quotations/{$quotationId}/AddTemplates',
      query: {
        specId: specId,
        customerId: customerId,
        quotationId: quotationId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to Add machines configured from template to Quotaton
   * @param specId
   * @param templateId
   * @param customerId
   * @param quotationId
   * @param requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static specAddMachinesByTemplateToQuotation(
    specId: string,
    templateId: string,
    customerId: number,
    quotationId: string,
    requestBody: Array<number>
  ): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}/Quotations/{$quotationId}/AddMachines',
      query: {
        specId: specId,
        templateId: templateId,
        customerId: customerId,
        quotationId: quotationId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to Add attachments configured from template to Quotaton
   * @param specId
   * @param templateId
   * @param customerId
   * @param quotationId
   * @param requestBody
   * @returns string OK
   * @throws ApiError
   */
  public static specAddAttachmentsByTemplateToQuotation(
    specId: string,
    templateId: string,
    customerId: number,
    quotationId: string,
    requestBody: Array<number>
  ): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}/Quotations/{$quotationId}/AddAttachments',
      query: {
        specId: specId,
        templateId: templateId,
        customerId: customerId,
        quotationId: quotationId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Returns all archived machines and attachments contained in a spec template
   * @param specId
   * @param customerId
   * @returns ArchivedEquipmentDto OK
   * @throws ApiError
   */
  public static specsSpecsWithArchivedEquipment(
    specId: string,
    customerId: number
  ): CancelablePromise<ArchivedEquipmentDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Customers/Specs/GetArchivedEquipmentBySpec',
      query: {
        specId: specId,
        customerId: customerId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to Add Spec to Quotaton
   * @param specId
   * @param customerId
   * @param quotationId
   * @returns string OK
   * @throws ApiError
   */
  public static specAddSpecToQuotation(
    specId: string,
    customerId: number,
    quotationId: string
  ): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/{$specId}/Quotations/{$quotationId}/AddSpec',
      query: {
        specId: specId,
        customerId: customerId,
        quotationId: quotationId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to make a copy of selected spec
   * @param customerId
   * @param specId
   * @returns any OK
   * @throws ApiError
   */
  public static specClone(
    customerId: number,
    specId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/{$specId}/Clone',
      query: {
        customerId: customerId,
        specId: specId
      }
    })
  }

  /**
   * Method allows you to make a copy of selected spec to customer
   * @param customerId
   * @param specId
   * @param targetCustomerId
   * @returns any OK
   * @throws ApiError
   */
  public static specCopyToCustomer(
    customerId: number,
    specId: string,
    targetCustomerId: number
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/{$specId}/CopyToCustomer/{$targetCustomerId}',
      query: {
        customerId: customerId,
        specId: specId,
        targetCustomerId: targetCustomerId
      }
    })
  }

  /**
   * Method allows you to make a copy of selected template for machine/attachment
   * @param customerId
   * @param sourceSpecId
   * @param targetSpecId
   * @param sourceTemplateId
   * @param requestBody
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static specCopyToItem(
    customerId: number,
    sourceSpecId: string,
    targetSpecId: string,
    sourceTemplateId: string,
    requestBody: Array<number>
  ): CancelablePromise<Array<SpecificationDto>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Spec/{sourceSpecId}/Template/{sourceTemplateId}/CopyToSpec/{targetSpecId}/ForItems',
      path: {
        sourceSpecId: sourceSpecId,
        targetSpecId: targetSpecId,
        sourceTemplateId: sourceTemplateId
      },
      query: {
        customerId: customerId
      },
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Method allows you to Create Templates in Quotaton to edit in cache
   * @param specId
   * @param customerId
   * @param templateId
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static specTemplatestoEdit(
    specId: string,
    customerId: number,
    templateId: string
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}/InCache',
      query: {
        specId: specId,
        customerId: customerId,
        templateId: templateId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to Create Templates in Quotation for Attachment and edit in cache
   * @param customerId
   * @param specId
   * @param templateId
   * @param attachmentId
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static specTemplatestoEditForAttachment(
    customerId: number,
    specId: string,
    templateId: string,
    attachmentId: string
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Customers/{$customerId}/Specs/{$specId}/Templates/{$templateId}/Attachment/{$attachmentId}/InCache',
      query: {
        customerId: customerId,
        specId: specId,
        templateId: templateId,
        attachmentId: attachmentId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update note in specification
   * @param customerId
   * @param specId
   * @param requestBody
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static customersUpdateSpecNote(
    customerId: number,
    specId: string,
    requestBody: string
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Customers/{$customerId}/Specs/{$specId}/Note',
      query: {
        customerId: customerId,
        specId: specId
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to update specification name
   * @param customerId
   * @param specId
   * @param specName
   * @returns SpecificationDto OK
   * @throws ApiError
   */
  public static customersUpdateSpecName(
    customerId: number,
    specId: string,
    specName: string
  ): CancelablePromise<SpecificationDto> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Customers/{$customerId}/Specs/{$specId}/Name',
      query: {
        customerId: customerId,
        specId: specId,
        specName: specName
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get compatible machines for template item
   * @param specId
   * @param templateId
   * @returns MachineCompatibilityDto OK
   * @throws ApiError
   */
  public static customersSpecsTemplateCompatibleMachines(
    specId: string,
    templateId: string
  ): CancelablePromise<Array<MachineCompatibilityDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Customers/Specs/Template/CompatibleMachines',
      query: {
        specId: specId,
        templateId: templateId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to get QuotationInternalApprovalRuleCheckData
   * @param quotationId
   * @returns InternalApprovalRuleCheckDto OK
   * @throws ApiError
   */
  public static quotationInternalApprovalRuleCheckData(
    quotationId: string
  ): CancelablePromise<InternalApprovalRuleCheckDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Internal/QuotationInternalApprovalRuleCheckData',
      query: {
        quotationId: quotationId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postInternalUpdateMergedCustomersEvent(
    requestBody: CustomerPubSubData
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/update_merged_customers_event',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postInternalChangeCustomerContactEvent(
    requestBody: CustomerContactChangePubSubData
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/change_customer_contact_event',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postInternalDeleteDeliveryLocation(
    requestBody: DeleteCustomerDeliveryLocationPubSubData
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/delete_delivery_location',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static postInternalDeleteBillingAddress(
    requestBody: DeleteCustomerBillingAddressPubSubData
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/delete_billing_address',
      body: requestBody,
      mediaType: 'application/json'
    })
  }

  /**
   * Create quick price quotation for machine
   * @param machineId
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static quickPriceMachineCreateQuickPriceDraft(
    machineId: number
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/QuickPrice/Machine/CreateQuickPriceDraft',
      query: {
        machineId: machineId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Create quick price quotation for attachment
   * @param attachmentId
   * @returns QuotationDto OK
   * @throws ApiError
   */
  public static quickPriceAttachmentCreateQuickPriceDraft(
    attachmentId: number
  ): CancelablePromise<QuotationDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/QuickPrice/Attachment/CreateQuickPriceDraft',
      query: {
        attachmentId: attachmentId
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * Method allows you to set sell price for machine attachment within machine for quotation
   * @param quotationId
   * @param machineItemId
   * @param attachmentItemId
   * @param sellPrice
   * @returns MachineAttachmentItemUpdateDto OK
   * @throws ApiError
   */
  public static quickPriceMachineMachineAttachmentSellPrice(
    quotationId: string,
    machineItemId: string,
    attachmentItemId: string,
    sellPrice: number
  ): CancelablePromise<MachineAttachmentItemUpdateDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/QuickPrice/Machine/MachineAttachment/SellPrice',
      query: {
        quotationId: quotationId,
        machineItemId: machineItemId,
        attachmentItemId: attachmentItemId,
        sellPrice: sellPrice
      },
      errors: {
        404: `Not Found`
      }
    })
  }

  /**
   * @param requestBody
   * @returns any OK
   * @throws ApiError
   */
  public static handleCultureChangedEventMachineApi(
    requestBody: CultureChangedEventData
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Internal/Culture/Changed',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`
      }
    })
  }

  /**
   * @returns CultureResponseDto OK
   * @throws ApiError
   */
  public static getCultureSettingsMachineApi(): CancelablePromise<CultureResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Culture'
    })
  }

  /**
   * @returns string OK
   * @throws ApiError
   */
  public static getSupportedCulturesMachineApi(): CancelablePromise<
    Array<string>
  > {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Culture/Supported'
    })
  }
}
